/**
 * Clés FR absentes de ukTranslations — couverture 100 % pour la locale « uk ».
 * Valeurs EN par défaut (équivalent au repli i18next) ; à remplacer par des traductions natives.
 * Généré par scripts/build-all-lang-gaps.mjs (relancer après ajout de clés en frTranslations).
 */
export const ukGapTranslations: Record<string, string> = {
  "profile.institution": "Institution",
  "profile.institutionHint": "Your LyrraStudio account is linked to this institution. This link is managed by your administrator.",
  "profile.institutionUnknownName": "Institution (name unavailable)",
  "nav.codir": "CODIR",
  "nav.webinars": "Webinars",
  "webinar.room.capacityFull": "This room has reached its maximum capacity ({{max}} people connected at once). Please try again later.",
  "webinar.room.speechTab": "Speech",
  "webinar.room.speechPanelHint": "Text captured from presenters’ microphones (browser speech recognition). The name shown is the person currently speaking.",
  "webinar.room.speechEmpty": "When a presenter speaks with the microphone on, their words appear here with their name. Punctuation follows the browser’s transcript.",
  "webinar.room.speechUnknownSpeaker": "Presenter",
  "webinar.room.speechPresenterActive": "Your voice is transcribed by the browser and sent to participants (Speech tab).",
  "webinar.room.speechUnsupportedBrowser": "Automatic presenter captions are not available in this browser (try Chrome or Edge).",
  "webinar.room.leave": "Leave room",
  "webinar.room.contentFocusExpand": "Content fills the stage",
  "webinar.room.contentFocusCollapse": "Show backdrop and presenters",
  "webinar.room.contentFocusAriaExpand": "Expand shared course, uploaded document or screen share full width without stage backdrop or presenter cameras",
  "webinar.room.liveDocumentLabel": "Upload (PDF or PowerPoint)",
  "webinar.room.liveDocumentUploadChoice": "Pick a file to display",
  "webinar.room.liveDocumentUploading": "Uploading…",
  "webinar.room.liveDocumentClose": "Remove document",
  "webinar.room.liveDocumentBehindScreen": "The document stays available — stop screen sharing to show it again.",
  "webinar.room.waitingSharedContentExtended": "Waiting for the presenter to share a catalog course, a file (PDF or PowerPoint), or their screen.",
  "webinar.room.liveDocumentOfficeHint": "If preview fails (plain HTTP locally or oversized file), use the link above.",
  "webinar.room.liveDocumentOpenOrDownload": "Open or download the file",
  "webinar.room.liveDocumentNoInlinePreview": "This file cannot be embedded automatically. Open it in a new tab.",
  "webinar.room.liveDocumentOpenTab": "Open",
  "webinar.room.pollTab": "Poll",
  "webinar.room.poll.regionTitle": "Webinar poll",
  "webinar.room.poll.presenterHint": "Add a question and 2–8 answers. Everyone sees the poll here; only hosts see live results.",
  "webinar.room.poll.questionLabel": "Question",
  "webinar.room.poll.questionPlaceholder": "E.g. Which topic should we cover next?",
  "webinar.room.poll.optionsLabel": "Answer choices",
  "webinar.room.poll.optionNumber": "Answer",
  "webinar.room.poll.choiceLabel": "Choice",
  "webinar.room.poll.addOption": "Add an answer",
  "webinar.room.poll.removeLastOption": "Remove last",
  "webinar.room.poll.launch": "Start poll",
  "webinar.room.poll.waitingParticipant": "No active poll yet. The host can start one.",
  "webinar.room.poll.voteHint": "One vote saved per person: you can change your answer by picking another option.",
  "webinar.room.poll.yourVote": "your pick",
  "webinar.room.poll.resultsHeading": "Results (hosts)",
  "webinar.room.poll.noVotesYet": "No votes yet.",
  "webinar.room.poll.totalVotes": "Total votes: {{n}}",
  "webinar.room.poll.closePoll": "Close poll",
  "webinar.room.contentFocusAriaCollapse": "Restore stage backdrop and presenter column",
  "webinar.room.exitDirectTitle": "Leave this webinar?",
  "webinar.room.exitDirectMessage": "You opened this room from a direct link (not from the dashboard). You can close this tab. If the browser blocks closing, you will be redirected to your home area.",
  "webinar.room.exitDirectConfirm": "Close tab",
  "webinar.room.publicGateTitle": "Webinar signup",
  "webinar.room.publicGateHint": "The organizer enabled public signup: enter your email, choose a password (min. 8 characters) and complete the requested fields.",
  "webinar.room.publicGateEmail": "Email",
  "webinar.room.publicGateLogin": "Login",
  "webinar.room.publicGatePassword": "Password",
  "webinar.room.publicGatePasswordHintParticipant": "First visit: registration. Next visits: same email and password. Minimum 8 characters.",
  "webinar.room.publicGateSubmit": "Enter room",
  "webinar.room.publicGateSubmitting": "Verifying…",
  "webinar.room.publicGateDenied": "Incorrect email or password.",
  "webinar.room.socketGateDenied": "Could not join the live room: public signup session missing or expired. Reload the page and sign in again with the same email and password.",
  "breadcrumb.dashboard": "Dashboard",
  "breadcrumb.projects": "Projects",
  "breadcrumb.eduflow": "Courses",
  "breadcrumb.learners": "Learners",
  "breadcrumb.analytics": "Analytics",
  "breadcrumb.videos": "Videos",
  "breadcrumb.sounds": "Sounds",
  "breadcrumb.images": "Images",
  "breadcrumb.documents": "Documents",
  "breadcrumb.store": "Store",
  "breadcrumb.help": "Help",
  "breadcrumb.admin": "Administration",
  "breadcrumb.settings": "Settings",
  "breadcrumb.profile": "Profile",
  "breadcrumb.groups": "Groups",
  "breadcrumb.branding": "Branding",
  "breadcrumb.landingPage": "Landing page",
  "breadcrumb.webhooks": "Webhooks",
  "breadcrumb.campaigns": "Campaigns",
  "breadcrumb.competencies": "Competencies",
  "breadcrumb.compliance": "Compliance",
  "breadcrumb.reports": "Reports",
  "breadcrumb.budget": "Budget",
  "breadcrumb.catalog": "Catalog",
  "breadcrumb.integrations": "Integrations",
  "breadcrumb.requests": "Requests",
  "breadcrumb.team": "Team",
  "breadcrumb.reviews": "Reviews",
  "breadcrumb.training": "Training",
  "breadcrumb.skills": "Skills",
  "breadcrumb.certificates": "Certificates",
  "breadcrumb.new": "New",
  "breadcrumb.edit": "Edit",
  "breadcrumb.podcasts": "Podcasts",
  "breadcrumb.episodes": "Episodes",
  "breadcrumb.parcours": "Learning paths",
  "breadcrumb.producerAssignments": "Production missions",
  "header.backToInstitutionAdmin": "Institution administration",
  "header.openTrainerWorkspace": "Trainer workspace & create content",
  "role.institution_admin": "Organization administrator",
  "role.resp_formation": "Training manager",
  "dashboard.certificatesIssued": "Certificates issued",
  "dashboard.searchProjects": "Search projects...",
  "dashboard.noProjects": "No projects yet",
  "dashboard.createFirst": "Create your first project to get started",
  "dashboard.createProject": "Create project",
  "dashboard.projectTitle": "Project title",
  "dashboard.calendar.mon": "Mon",
  "dashboard.calendar.wed": "Wed",
  "dashboard.calendar.fri": "Fri",
  "dashboard.calendar.less": "Less",
  "dashboard.calendar.more": "More",
  "dashboard.calendar.tooltip": "{{count}} activit(ies) on {{date}}",
  "dashboard.mock.updated2h": "2h ago",
  "dashboard.mock.updated5h": "5h ago",
  "dashboard.mock.updatedYesterday": "Yesterday",
  "pages.help.title": "Help center",
  "pages.help.description": "Documentation and support",
  "pages.help.hubIntro": "Topics covering how to use Lyrra — you will soon be able to link each card to your docs, tutorials, or support tickets.",
  "pages.help.searchPlaceholder": "Search topics…",
  "pages.help.noResults": "No results for this search.",
  "pages.help.configHint": "Sample content: wire up your URLs, articles, or knowledge base when you are ready.",
  "pages.help.comingSoonDesc": "Access documentation, tutorials, and technical support to get the most out of the platform.",
  "pages.help.modal.steps": "In practice",
  "pages.help.modal.tips": "Tips",
  "pages.help.modal.related": "See also",
  "pages.help.openArticle": "Open article",
  "pages.help.onboardingFlowMissing": "Training not found",
  "pages.help.onboardingFlowMissingDesc": "Run backend seeds (db:seed:onboarding-eduflow, db:seed:onboarding-navigation-eduflow, db:seed:onboarding-profile-eduflow, db:seed:onboarding-roles-eduflow, db:seed:onboarding-block-types-eduflow, db:seed:onboarding-designer-overview-eduflow, db:seed:onboarding-branches-eduflow, db:seed:onboarding-validation-eduflow, db:seed:onboarding-objectives-eduflow, db:seed:onboarding-ai-designer-eduflow, db:seed:onboarding-publication-status-eduflow, db:seed:onboarding-publication-links-eduflow, db:seed:onboarding-catalog-visibility-eduflow, db:seed:onboarding-enrollments-eduflow, db:seed:onboarding-groups-cohorts-eduflow, db:seed:onboarding-progress-eduflow, db:seed:onboarding-certificates-eduflow, and db:seed:onboarding-media-library-eduflow) or set VITE_ONBOARDING_DASHBOARD_FLOW_ID / VITE_ONBOARDING_NAVIGATION_FLOW_ID / VITE_ONBOARDING_PROFILE_FLOW_ID / VITE_ONBOARDING_ROLES_FLOW_ID / VITE_ONBOARDING_BLOCK_TYPES_FLOW_ID / VITE_ONBOARDING_DESIGNER_OVERVIEW_FLOW_ID / VITE_ONBOARDING_BRANCHES_FLOW_ID / VITE_ONBOARDING_VALIDATION_FLOW_ID / VITE_ONBOARDING_OBJECTIVES_FLOW_ID / VITE_ONBOARDING_AI_DESIGNER_FLOW_ID / VITE_ONBOARDING_PUBLICATION_STATUS_FLOW_ID / VITE_ONBOARDING_PUBLICATION_LINKS_FLOW_ID / VITE_ONBOARDING_CATALOG_VISIBILITY_FLOW_ID / VITE_ONBOARDING_ENROLLMENTS_FLOW_ID / VITE_ONBOARDING_GROUPS_COHORTS_FLOW_ID / VITE_ONBOARDING_PROGRESS_FLOW_ID / VITE_ONBOARDING_CERTIFICATES_FLOW_ID / VITE_ONBOARDING_MEDIA_LIBRARY_FLOW_ID.",
  "pages.help.onboardingDashboardPlayerTitle": "Training — Lyrra creator dashboard (onboarding)",
  "pages.help.onboardingNavigationPlayerTitle": "Training — Lyrra navigation & sidebar (onboarding)",
  "pages.help.onboardingProfilePlayerTitle": "Training — Lyrra profile & preferences (onboarding)",
  "pages.help.onboardingRolesPlayerTitle": "Training — Lyrra roles and access rights (onboarding)",
  "pages.help.onboardingBlockTypesPlayerTitle": "Training — EduFlow block types (onboarding)",
  "pages.help.onboardingDesignerOverviewPlayerTitle": "Training — EduFlow designer overview (onboarding)",
  "pages.help.onboardingBranchesPlayerTitle": "Training — EduFlow branches & conditions (onboarding)",
  "pages.help.onboardingValidationPlayerTitle": "Training — EduFlow parcours validation (onboarding)",
  "pages.help.onboardingObjectivesPlayerTitle": "Training — EduFlow learning objectives (onboarding)",
  "pages.help.onboardingAiDesignerPlayerTitle": "Training — LyrraStudio AI designer assistant (onboarding)",
  "pages.help.onboardingPublicationStatusPlayerTitle": "Training — LyrraStudio draft, publication and updates (onboarding)",
  "pages.help.onboardingPublicationLinksPlayerTitle": "Training — LyrraStudio access links and sharing (onboarding)",
  "pages.help.onboardingCatalogVisibilityPlayerTitle": "Training — LyrraStudio catalog and visibility (onboarding)",
  "pages.help.onboardingEnrollmentsPlayerTitle": "Training — LyrraStudio enrollments & participants (onboarding)",
  "pages.help.onboardingGroupsCohortsPlayerTitle": "Training — LyrraStudio groups & cohorts (onboarding)",
  "pages.help.onboardingProgressPlayerTitle": "Training — LyrraStudio progress & time spent (onboarding)",
  "pages.help.onboardingCertificatesPlayerTitle": "Training — LyrraStudio delivered certificates (onboarding)",
  "pages.help.onboardingMediaLibraryPlayerTitle": "Training — LyrraStudio media library (onboarding)",
  "dashboard.vsLastPeriod": "vs previous period ({{period}})",
  "dashboard.activeLearners": "Active learners",
  "dashboard.sessions": "Sessions",
  "dashboard.activityType.completion": "Completed",
  "dashboard.activityType.enrollment": "Enrollment",
  "dashboard.activityType.milestone": "Milestone",
  "dashboard.activityType.feedback": "Feedback",
  "dashboard.activityType.start": "Start",
  "dashboard.activeEduFlows": "Active training paths",
  "dashboard.completionRate": "Completion rate",
  "dashboard.npsScore": "NPS score",
  "dashboard.topEduFlowsHint": "Completion rate among the most enrolled courses (sorted by learner count).",
  "dashboard.engagement": "Learner engagement",
  "podcast.createEpisode.coverTooLarge": "Image must be 5 MB or smaller.",
  "eduflow.list.archiveFormation": "Archive course",
  "eduflow.list.restoreFromArchive": "Restore from archive (draft)",
  "eduflow.list.archiveSuccess": "Course archived",
  "eduflow.list.archiveError": "Could not archive the course.",
  "eduflow.list.restoreSuccess": "Course restored as draft",
  "eduflow.list.restoreError": "Could not restore the course.",
  "eduflow.versionHistory.create": "Create a version",
  "eduflow.versionHistory.createVersion": "Create v{{version}}",
  "eduflow.versionHistory.minor": "Minor",
  "eduflow.versionHistory.major": "Major",
  "eduflow.versionHistory.minorBadge": "Minor version",
  "eduflow.versionHistory.majorBadge": "Major version",
  "eduflow.versionHistory.publish": "Publish this version",
  "eduflow.versionHistory.publishCta": "Publish",
  "eduflow.versionHistory.systemPublished": "Published {{version}}",
  "eduflow.versionHistory.systemSaved": "Saved {{version}}",
  "eduflow.versionHistory.systemAutosaveRestore": "Auto-save before restoring {{version}}",
  "eduflow.versionHistory.descriptionPlaceholder": "Describe the changes…",
  "eduflow.versionHistory.restoreTitle": "Restore version v{{version}}?",
  "eduflow.versionHistory.restoreWarning": "The current content will be replaced. An automatic backup will be created before the restore.",
  "eduflow.versionHistory.createSuccess": "Version {{version}} created",
  "eduflow.versionHistory.restoreSuccess": "Version {{version}} restored",
  "eduflow.versionHistory.restoreError": "Error while restoring the version",
  "eduflow.versionHistory.publishSuccess": "Version {{version}} published",
  "eduflow.versionHistory.publishError": "Error while publishing the version",
  "eduflow.versionHistory.now": "just now",
  "eduflow.designer.paletteCategory.structure": "Path & structure",
  "eduflow.designer.paletteCategory.content": "Content & media",
  "eduflow.designer.paletteCategory.interactive": "Activities & assessment",
  "eduflow.designer.paletteCategory.accessibility": "Accessibility (DYS)",
  "eduflow.designer.paletteCategory.enterprise": "Compliance & advanced",
  "eduflow.designer.flowSettings.toolbarTitle": "Course & player settings",
  "eduflow.designer.flowSettings.panelTitle": "Course settings",
  "eduflow.designer.flowSettings.intro": "Shown in the player (title, description, cover). You can hide the “Previous” button for a strictly linear path.",
  "eduflow.designer.flowSettings.titleLabel": "Course title",
  "eduflow.designer.flowSettings.descriptionLabel": "Course description",
  "eduflow.designer.flowSettings.coverLabel": "Cover image",
  "eduflow.designer.flowSettings.coverUpload": "Upload an image",
  "eduflow.designer.flowSettings.coverUrlPlaceholder": "Or paste an image URL (https://…)",
  "eduflow.designer.flowSettings.coverRemove": "Remove cover",
  "eduflow.designer.flowSettings.allowPreviousLabel": "“Previous” button in the player",
  "eduflow.designer.flowSettings.allowPreviousHint": "When off, learners cannot go back to the previous block (including keyboard shortcuts).",
  "eduflow.designer.blockLabel.start": "Start",
  "eduflow.designer.blockLabel.end": "End",
  "eduflow.summary.editorHint": "List the concepts or steps covered in the course. Each line appears as a numbered card in the player.",
  "eduflow.designer.blockLabel.form": "Form",
  "eduflow.designer.blockLabel.loop": "Loop",
  "eduflow.designer.blockLabel.merge": "Merge",
  "eduflow.designer.blockLabel.split": "Branch",
  "eduflow.designer.blockLabel.subflow": "Sub-training",
  "eduflow.designer.blockLabel.timer": "Timer",
  "eduflow.designer.blockLabel.email": "Automated email",
  "eduflow.designer.blockLabel.text": "Text",
  "eduflow.designer.blockLabel.podcast": "Podcast",
  "eduflow.designer.blockLabel.video": "Video",
  "eduflow.designer.blockLabel.image": "Annotated image",
  "eduflow.designer.blockLabel.pdf": "PDF document",
  "eduflow.designer.blockLabel.browser": "Embedded web page",
  "eduflow.designer.blockLabel.presentation": "Slideshow",
  "eduflow.designer.blockLabel.timeline": "Timeline",
  "eduflow.designer.blockLabel.chart": "Interactive chart",
  "eduflow.designer.blockLabel.mindmap": "Mind map",
  "eduflow.designer.blockLabel.visual_ai": "AI visual",
  "eduflow.designer.blockLabel.quiz_mcq": "Quiz (MCQ / T-F / order)",
  "eduflow.designer.blockLabel.poll": "Live poll",
  "eduflow.designer.blockLabel.self_assessment": "Self-assessment",
  "eduflow.selfAssessment.panelHint": "Define each dimension to rate: a short title and, if needed, a description to guide the learner.",
  "eduflow.selfAssessment.emptyCriteria": "No criteria yet. Add at least one so learners can self-assess.",
  "eduflow.selfAssessment.criterionTitlePh": "e.g. Communication, Autonomy…",
  "eduflow.selfAssessment.criterionDescriptionPh": "Clarify what the learner should reflect on or observe…",
  "eduflow.selfAssessment.badgeOptionsHint": "Short words or phrases — learners pick them as chips. If empty → free-text field.",
  "eduflow.selfAssessment.textModeHint": "Learners write an answer for each criterion. The global comment field remains below in the player.",
  "eduflow.designer.blockLabel.evaluation": "Multi-question assessment",
  "eduflow.designer.blockLabel.phrase_reveal": "Progressive reveal",
  "eduflow.designer.blockLabel.voice_assessment": "Voice assessment",
  "eduflow.designer.blockLabel.dys_reader": "DYS reader (syllables + TTS)",
  "eduflow.designer.blockLabel.dys_image_zones": "Interactive image zones",
  "eduflow.designer.blockLabel.dys_clock": "DYS color clock",
  "eduflow.designer.blockLabel.dys_reading_practice": "Adapted reading exercise",
  "eduflow.designer.blockLabel.glossary": "Glossary + built-in quiz",
  "eduflow.designer.blockLabel.html": "Custom HTML / JavaScript",
  "eduflow.designer.blockLabel.certification": "Certificate (Word template)",
  "eduflow.designer.blockLabel.signature": "Learner signature",
  "eduflow.designer.blockLabel.facial_recognition": "Facial recognition",
  "eduflow.designer.blockLabel.attendance": "Digital attendance",
  "eduflow.designer.startBlockTitle": "Start",
  "eduflow.designer.placeholderUntitled": "Untitled",
  "eduflow.designer.placeholderFlowDescription": "Training description (max 255 characters)",
  "eduflow.designer.saving": "Saving…",
  "eduflow.designer.unsaved": "Not saved",
  "eduflow.designer.saved": "Saved",
  "eduflow.designer.blocksPanelTitle": "Blocks",
  "eduflow.designer.paletteSearchLabel": "Search blocks",
  "eduflow.designer.paletteSearchPlaceholder": "Search blocks…",
  "eduflow.designer.paletteSearchEmpty": "No blocks match your search.",
  "eduflow.designer.autoLayoutShort": "Auto-layout",
  "eduflow.designer.validate": "Validate",
  "eduflow.designer.validateTitle": "Validate path",
  "eduflow.designer.validationBeforePreview": "Fix path errors before preview.",
  "eduflow.designer.validationBeforePublish": "Fix path errors before publishing.",
  "eduflow.designer.aiShort": "AI",
  "eduflow.designer.aiTitle": "AI assistant",
  "eduflow.designer.ragChatbotTitle": "Course chatbot",
  "eduflow.ragChatbot.needDoc": "Add at least one document before enabling the chatbot.",
  "eduflow.ragChatbot.uploadSavedNotIndexed": "Document saved. It will not be used for RAG until the vector store is configured on the server.",
  "eduflow.ragChatbot.ragIndexFailed": "Document saved but not indexed. Check pgvector (DATABASE_VECTOR_URL) and Mistral, then re-upload if needed.",
  "eduflow.ragChatbot.vectorHint": "To index PDF / TXT / MD: set DATABASE_VECTOR_URL or PGVECTOR_HOST (PostgreSQL + pgvector) and Mistral in Admin → Platform integrations (API key + embedding model). Otherwise upload and indexing fail.",
  "eduflow.ragChatbot.chatHint": "Player answers and RAG embeddings use Mistral. Uploaded documents are retrieved with Mistral embeddings + pgvector; with no documents, only block text is used as context.",
  "eduflow.ragChatbot.playerToggleHint": "Learners ask questions only about this course: block text in the path, plus indexed documents if you added any.",
  "eduflow.ragChatbot.docCount": "Indexed documents: {{count}}",
  "eduflow.ragChatbot.playerDisclaimer": "Answers are based on this course’s documents and content only.",
  "eduflow.designer.aiPanel.welcome": "Hi! I work like an **in-app assistant** (similar to Copilot in Word), but for your **EduFlow course**: writing and fixing block text, path structure, quizzes and activities, objectives, accessibility, pedagogy, translations — anything expressible on the canvas or in the Objectives panel. The block open on the right is the **default target** for short commands (“rewrite”, “translate”). Turn on **auto-apply** to run changes without extra clicks.",
  "eduflow.designer.aiPanel.subtitle": "Course copilot: content, graph, assessments, and objectives — executed directly in the designer.",
  "eduflow.designer.aiPanel.focusContextLabel": "The AI sees:",
  "eduflow.designer.aiPanel.focusPrimary": "Properties-focused block: \"{{label}}\" ({{type}}). Vague requests target this node.",
  "eduflow.designer.aiPanel.focusMulti": "{{count}} blocks selected — say which to edit, or focus a single node (click + Properties).",
  "eduflow.designer.aiPanel.focusNone": "no focused block — pick a node on the canvas or name the block in your message.",
  "eduflow.designer.aiPanel.followUpsLabel": "Suggested next steps",
  "eduflow.designer.aiPanel.ideasToggle": "One‑click prompts to try",
  "eduflow.designer.aiPanel.webSourcesLabel": "Web pages for this turn (optional — up to 3 URLs fetched server-side)",
  "eduflow.designer.aiPanel.webSourcesPlaceholder": "https://example.org/doc\nhttps://…",
  "eduflow.designer.aiPanel.idea.auditPath": "Audit the graph: broken paths, isolated nodes and flow order — apply fixes",
  "eduflow.designer.aiPanel.idea.microLearning": "Design a concise micro‑learning variant from the current flow while preserving intent",
  "eduflow.designer.aiPanel.idea.formativeGap": "Insert short formative bridging activities wherever the pathway is cognitively heavy",
  "eduflow.designer.aiPanel.idea.titleCoherence": "Align block titles with the project title and the overall training tone",
  "eduflow.designer.aiPanel.idea.remediation": "Add a remediation path after the main MCQ quiz (failure / low-score branch)",
  "eduflow.designer.aiPanel.idea.mobileWording": "Shorten and clarify HTML text in blocks that are too long on mobile",
  "eduflow.designer.aiPanel.idea.quizWording": "Unify wording style across all quiz instructions (“Select…”, tone, formal register)",
  "eduflow.designer.aiPanel.idea.summaryBeforeEnd": "Add or rewrite a recap block immediately before the End node",
  "eduflow.designer.aiPanel.streamMode": "Stream responses",
  "eduflow.designer.aiPanel.streamModeHint": "Token-by-token display while Mistral generates; the final payload is still normalized like classic mode.",
  "eduflow.designer.aiPanel.streamError": "Stream interrupted or refused.",
  "eduflow.designer.aiPanel.streamIncomplete": "Incomplete response from server. Retry or disable streaming.",
  "eduflow.designer.aiPanel.skillPath": "Server skill: path audit",
  "eduflow.designer.aiPanel.skillPathHint": "Structural report (start/end, edges, reachability) appended to the prompt.",
  "eduflow.designer.aiPanel.skillQuiz": "Server skill: strict MCQ schema",
  "eduflow.designer.aiPanel.skillQuizHint": "Official Lyrra quiz_mcq settings template embedded in the prompt.",
  "eduflow.designer.aiPanel.serverSkills": "Server skills",
  "eduflow.designer.aiPanel.quickActions": "Quick actions",
  "eduflow.designer.aiPanel.placeholder": "Ask a question, brainstorm, review content, or change the path…",
  "eduflow.designer.aiPanel.apply": "Apply to canvas",
  "eduflow.designer.aiPanel.autoApply": "Automatically apply operations to the canvas",
  "eduflow.designer.aiPanel.autoApplyHint": "When enabled, each structured response updates the path without clicking Apply.",
  "eduflow.designer.aiPanel.dismissOps": "Dismiss",
  "eduflow.designer.aiPanel.applied": "Changes applied to the path.",
  "eduflow.designer.aiPanel.applyPartial": "Applied with warnings: {{details}}",
  "eduflow.designer.aiPanel.applyFailed": "No operations could be applied to the canvas (invalid operation format or block types).",
  "eduflow.designer.aiPanel.objectivesSaved": "Learning objectives saved (Objectives panel).",
  "eduflow.designer.aiPanel.objectivesSaveError": "Could not save objectives. Please try again.",
  "eduflow.designer.aiPanel.error": "Could not reach the assistant. Check your AI configuration (API key) and network.",
  "eduflow.designer.aiPanel.newConversation": "New conversation",
  "eduflow.designer.aiPanel.clearConversation": "Clear conversation",
  "eduflow.designer.aiPanel.conversationHistory": "History",
  "eduflow.designer.aiPanel.deleteConversation": "Delete",
  "eduflow.designer.aiPanel.maxConversations": "You’ve reached the limit of {{max}} saved conversations. Delete one to start a new one.",
  "eduflow.designer.aiPanel.unnamedConversation": "Conversation",
  "eduflow.designer.aiQuick.plan": "Suggest a path plan",
  "eduflow.designer.aiQuick.expand": "Enrich with interactive blocks",
  "eduflow.designer.aiQuick.quiz": "Add a quiz module",
  "eduflow.designer.aiQuick.objectives": "Fill learning objectives (Objectives panel)",
  "eduflow.designer.aiQuick.rewriteFocus": "Rewrite the open block — clearer and pedagogical",
  "eduflow.designer.aiQuick.translateFocus": "Translate the open block into French",
  "eduflow.designer.voiceShort": "Voice",
  "eduflow.designer.voiceTitle": "Voice settings",
  "eduflow.designer.objectivesShort": "Objectives",
  "eduflow.designer.objectivesTitle": "Learning objectives",
  "eduflow.designer.flowVariablesTitle": "Global variables",
  "eduflow.designer.flowVariables.subtitle": "Set key / value pairs. Use @ followed by the key name in block titles and descriptions (e.g. @course_name). Values are substituted for learners.",
  "eduflow.designer.flowVariables.empty": "No variables yet. Add some to personalize course wording.",
  "eduflow.designer.flowVariables.keyLabel": "Key",
  "eduflow.designer.flowVariables.keyPlaceholder": "e.g. course_name",
  "eduflow.designer.flowVariables.keyHelp": "Letters, numbers, hyphen and underscore only. @key matching is case-sensitive.",
  "eduflow.designer.flowVariables.valueLabel": "Default value",
  "eduflow.designer.flowVariables.valuePlaceholder": "Text shown instead of @key",
  "eduflow.designer.flowVariables.add": "Add variable",
  "eduflow.designer.flowVariables.delete": "Remove",
  "eduflow.designer.flowVariables.invalidKey": "Each key must be set and use only allowed characters.",
  "eduflow.designer.flowVariables.duplicateKey": "Duplicate keys (case-insensitive) are not allowed.",
  "eduflow.designer.flowVariables.savedToast": "Variables saved",
  "eduflow.designer.flowVariables.errorToast": "Could not save variables.",
  "eduflow.designer.flowVariables.saveNow": "Save now",
  "eduflow.designer.blockFlowVariablesHint": "Global variables: use @your_key in the title or description (configure them with the { } icon in the toolbar).",
  "eduflow.designer.blockFlowVariablesPreviewTitle": "Preview (title)",
  "eduflow.designer.blockFlowVariablesPreviewDescription": "Preview (description)",
  "eduflow.designer.flowVariables.mentionNoMatch": "No matching variable.",
  "eduflow.designer.formFieldsSlash.mentionNoMatch": "No matching field.",
  "eduflow.designer.onlineCount": "{{count}} online",
  "eduflow.designer.editingBlocks_one": "{{count}} block being edited",
  "eduflow.designer.editingBlocks_other": "{{count}} blocks being edited",
  "eduflow.designer.invite": "Invite",
  "eduflow.designer.inviteTitle": "Invite a collaborator",
  "eduflow.designer.exportTitle": "Export path",
  "eduflow.designer.importTitle": "Import course (file or JSON paste)",
  "eduflow.designer.exportNeedSavedFlow": "Save the course first to export a .lyrra package.",
  "eduflow.designer.canvasUntitled": "Untitled",
  "eduflow.designer.selectBlock": "Select a block",
  "eduflow.designer.selectBlockHint": "Click a block on the canvas to edit its properties",
  "eduflow.designer.blockPropertiesSubtitle": "Block properties",
  "eduflow.designer.blockLockedReadOnly": "This block is locked: properties are shown as read-only.",
  "eduflow.designer.blockTitleField": "Title",
  "eduflow.designer.blockTitlePlaceholder": "Block title",
  "eduflow.designer.you": "You",
  "eduflow.designer.blockInfoPosition": "ID: {{id}} | Position: ({{x}}, {{y}})",
  "eduflow.designer.toastBlockCopied": "Block copied",
  "eduflow.designer.toastCollaboratorInvited": "Collaborator invited",
  "eduflow.designer.toastInviteError": "Could not invite this collaborator",
  "eduflow.designer.createFlowError": "Could not create the path",
  "eduflow.designer.loadFlowError": "Could not load this training.",
  "eduflow.designer.loadFlowForbidden": "You do not have access to this training.",
  "eduflow.designer.loadFlowNotFound": "Training not found or removed.",
  "eduflow.designer.editConnection": "Edit connection",
  "eduflow.designer.deleteConnection": "Delete connection",
  "eduflow.translation.toolbarTitle": "Content translation",
  "eduflow.translation.toolbarShort": "Translate",
  "eduflow.translation.title": "Multilingual translation",
  "eduflow.translation.subtitle": "Translate block text (AI) and optionally regenerate description voiceovers. Results are stored per language.",
  "eduflow.translation.subtitleV2": "Pick a Mistral voice per language for description voiceovers in the player (on-demand translation). Batch translation jobs below are optional.",
  "eduflow.translation.voicesSection": "TTS voices per language",
  "eduflow.translation.voicesSectionHint": "Preview uses sample text in that language. With no voice selected, “Marie - sad” is used for French, Italian and Spanish; “Paul - sad” for other languages.",
  "eduflow.translation.voicesLangCount": "{{count}} languages (FR, EN, ES, DE, IT, PT, LB, UK, RU, AR): pick a voice, then tap “Play sample”.",
  "eduflow.translation.voicesLoadError": "Could not load voices. Check your connection or try again.",
  "eduflow.translation.voicePreview": "Play sample",
  "eduflow.translation.previewStop": "Stop",
  "eduflow.translation.voicePlaceholder": "— Choose a voice —",
  "eduflow.translation.voiceSelectAria": "Voice for {{lang}}",
  "eduflow.translation.voicesSaveError": "Could not save voices.",
  "eduflow.translation.selectVoiceFirst": "Choose a voice for this language first.",
  "eduflow.translation.previewError": "Audio playback failed.",
  "eduflow.translation.batchSection": "Precomputed translations (optional)",
  "eduflow.translation.batchSectionHint": "The player can translate on the fly; run a job only if you want text + audio stored ahead of time.",
  "eduflow.translation.sourceLang": "Course source language",
  "eduflow.translation.bulkSection": "All languages",
  "eduflow.translation.includeText": "Text",
  "eduflow.translation.includeAudio": "Audio (description voiceover)",
  "eduflow.translation.runAll": "Translate all languages (except source)",
  "eduflow.translation.runAllHint": "Starts one job per target language among the 10 supported languages, excluding the source language.",
  "eduflow.translation.perLanguage": "Per language",
  "eduflow.translation.sourceBadge": "Source",
  "eduflow.translation.runOne": "Translate",
  "eduflow.translation.history": "Recent jobs",
  "eduflow.translation.noHistory": "No jobs yet.",
  "eduflow.translation.saveFirst": "Save the path before starting a translation.",
  "eduflow.translation.prefsSaveError": "Could not save translation preferences (per-language Text / Audio toggles).",
  "eduflow.translation.jobStarted": "Translation started for {{lang}}.",
  "eduflow.translation.jobError": "Could not start translation.",
  "eduflow.translation.bulkStarted": "{{count}} translation job(s) started.",
  "eduflow.translation.bulkNone": "No new jobs: translations may already be running for all target languages, or no options were selected.",
  "eduflow.translation.bulkError": "Could not start bulk translations.",
  "eduflow.translation.statusPending": "Pending",
  "eduflow.translation.statusProcessing": "In progress",
  "eduflow.translation.statusCompleted": "Completed",
  "eduflow.translation.statusFailed": "Failed",
  "eduflow.translation.missingSourceAudioHint": "Audio translation: generate the description voiceover in {{lang}} for every long description first. Block(s) missing audio ({{count}}): {{blocks}}.",
  "eduflow.translation.missingSourceAudioToast": "{{count}} block(s) without source-language voiceover: {{blocks}}. Generate audio from the block properties, then try again.",
  "project.title": "Projects",
  "project.new": "New project",
  "project.name": "Project name",
  "project.description": "Project description",
  "project.status.in_review": "In review",
  "project.visibility.public": "Public",
  "project.visibility.private": "Private",
  "project.visibility.institution": "Organization",
  "project.no_projects": "No projects found",
  "project.delete_confirm": "Are you sure you want to delete this project?",
  "store.categories": "Categories",
  "store.price": "Price",
  "store.free": "Free",
  "store.buy": "Buy",
  "store.add_to_cart": "Add to cart",
  "store.cart": "Cart",
  "store.checkout": "Checkout",
  "store.reviews": "Reviews",
  "store.rating": "Rating",
  "store.my_purchases": "My purchases",
  "store.no_items": "No items found",
  "audio.title": "Audio Studio",
  "audio.audiobooks": "Audiobooks",
  "audio.new_audiobook": "New audiobook",
  "audio.record": "Record",
  "audio.stop": "Stop",
  "audio.play": "Play",
  "audio.pause": "Pause",
  "audio.volume": "Volume",
  "audio.tracks": "Tracks",
  "audio.add_track": "Add track",
  "audio.remove_track": "Remove track",
  "audio.effects": "Effects",
  "audio.export": "Export",
  "audio.export_format": "Export format",
  "audio.duration": "Duration",
  "audio.narrator": "Narrator",
  "audio.chapter": "Chapter",
  "notification.title": "Notifications",
  "notification.mark_all_read": "Mark all as read",
  "notification.no_notifications": "No notifications",
  "notification.new": "New notification",
  "notification.type.info": "Information",
  "notification.type.success": "Success",
  "notification.type.warning": "Warning",
  "notification.type.error": "Error",
  "settings.title": "Settings",
  "settings.general": "General",
  "settings.account": "Account",
  "settings.security": "Security",
  "settings.appearance": "Appearance",
  "settings.notifications": "Notifications",
  "settings.language": "Language",
  "settings.theme": "Theme",
  "settings.theme.light": "Light",
  "settings.theme.dark": "Dark",
  "settings.theme.system": "System",
  "settings.accessibility": "Accessibility",
  "settings.font_size": "Font size",
  "settings.high_contrast": "High contrast",
  "settings.reduced_motion": "Reduced motion",
  "settings.dyslexia_mode": "Dyslexia mode",
  "analytics.title": "Analytics",
  "analytics.overview": "Overview",
  "analytics.learner_progress": "Learner progress",
  "analytics.engagement": "Engagement",
  "analytics.completion": "Completion",
  "analytics.time_spent": "Time spent",
  "analytics.average_score": "Average score",
  "analytics.export_report": "Export report",
  "gamification.xp": "XP",
  "gamification.streak": "Streak",
  "gamification.achievements": "Achievements",
  "gamification.daily_goal": "Daily goal",
  "gamification.congratulations": "Congratulations!",
  "gamification.new_badge": "New badge unlocked!",
  "gamification.level_up": "Level up!",
  "qualiopi.title": "Qualiopi compliance",
  "qualiopi.dashboard": "Qualiopi dashboard",
  "qualiopi.criteria": "Criterion {{number}}",
  "qualiopi.indicator": "Indicator {{number}}",
  "qualiopi.compliant": "Compliant",
  "qualiopi.non_compliant": "Non-compliant",
  "qualiopi.partial": "Partially compliant",
  "qualiopi.not_applicable": "Not applicable",
  "qualiopi.upload_evidence": "Upload evidence",
  "qualiopi.audit_date": "Audit date",
  "qualiopi.next_audit": "Next audit",
  "qualiopi.compliance_score": "Compliance score",
  "qualiopi.action_plan": "Action plan",
  "training.plan": "Training plan",
  "training.request": "Training request",
  "training.requests": "Training requests",
  "training.catalog": "Training catalog",
  "training.budget": "Training budget",
  "training.campaign": "Interview campaign",
  "training.competency": "Skills framework",
  "training.gap_analysis": "Gap analysis",
  "training.roi": "Return on investment",
  "player.scrollDownHint": "Scroll down for more",
  "player.image.annotationNoDescription": "No description for this annotation.",
  "player.image.noneAvailable": "No image available",
  "player.fullscreen": "Fullscreen",
  "player.exitFullscreen": "Exit fullscreen",
  "player.webinarFollowBanner": "You are following the host — navigation is locked. You can change the display language using the globe button.",
  "player.institutionLogo": "Organization logo",
  "player.contentLanguageReloadFailed": "Could not reload content in this language (timeout or server error). The previous version is still shown. Try again shortly or precompute translations in the designer.",
  "player.contentLanguageSubflowHint": "To update text and audio, finish or leave the current sub-section, then pick the language again.",
  "player.mobileSummary": "Outline",
  "player.mobileObjectives": "Objectives",
  "player.mobileMoreOptions": "More options",
  "player.podcast.showChapters": "Show chapters",
  "player.podcast.hideChapters": "Hide chapters",
  "player.podcast.coverDialogLabel": "Cover artwork: {{title}}",
  "player.podcast.coverEnlargePodcast": "Enlarge podcast cover artwork",
  "player.podcast.coverEnlargeEpisode": "Enlarge episode cover artwork",
  "player.podcast.coverEnlarge": "Enlarge cover artwork",
  "player.audio.play": "Play",
  "player.audio.pause": "Pause",
  "player.audio.mute": "Mute",
  "player.audio.unmute": "Unmute",
  "player.audio.seek": "Audio track position",
  "player.audio.playbackSpeed": "Playback speed",
  "player.audio.completed": "Audio track finished",
  "player.video.seek": "Video position",
  "player.video.subtitlesShow": "Show subtitles",
  "player.video.subtitlesHide": "Hide subtitles",
  "player.video.trackLabel": "Subtitles",
  "player.video.completed": "Video completed",
  "player.video.markWatched": "I have watched the video",
  "player.video.defaultIframeTitle": "Embedded video",
  "player.podcast.playAllAria": "Play all “{{title}}” — {{count}} episode(s) with audio",
  "player.podcast.skipNextQueuedAria": "Skip to next episode in queue",
  "player.podcast.playEpisodeAria": "Play episode: {{title}}",
  "player.podcast.episodeNoAudioAria": "Episode with no audio file: {{title}}",
  "player.selfAssessment.commentPlaceholder": "Personal reflections, areas for growth…",
  "player.selfAssessment.textAnswerPlaceholder": "Your answer…",
  "learner.header.workspace": "Learner workspace",
  "learner.tabs.home": "Home",
  "learner.tabs.parcours": "My Paths",
  "learner.tabs.formations": "My Courses",
  "learner.tabs.webinars": "Webinars",
  "learner.tabs.podcasts": "Podcasts",
  "learner.tabs.documents": "Documents",
  "learner.tabs.progress": "My Progress",
  "learner.tabs.profile": "Profile",
  "learner.sidebar.webinars": "Webinars",
  "learner.webinars.title": "My webinars",
  "learner.webinars.loading": "Loading your webinars…",
  "learner.webinars.empty": "No webinars yet. When a trainer invites you by email, they will appear here.",
  "learner.webinars.join": "Join room",
  "learner.webinars.invitedOn": "Invited on",
  "learner.webinars.scheduledFor": "Scheduled for",
  "learner.webinars.duration": "Duration: {{duration}}",
  "learner.webinars.loadError": "Could not load webinars.",
  "learner.webinars.status.draft": "Draft",
  "learner.webinars.status.scheduled": "Scheduled",
  "learner.webinars.status.live": "Live",
  "learner.webinars.status.ended": "Ended",
  "learner.sidebar.myProfile": "My profile",
  "learner.sidebar.logout": "Log out",
  "learner.sidebar.backToTrainer": "Trainer dashboard",
  "learner.sidebar.backToTrainerAria": "Go back to the trainer dashboard",
  "learner.home.resumeTraining": "Resume your courses",
  "learner.home.viewAll": "View all →",
  "learner.home.trainingDomains": "Training domains",
  "learner.home.courses": "courses",
  "learner.home.episodes": "episodes",
  "learner.home.recommendedPodcasts": "Recommended podcasts",
  "learner.home.explore": "Explore →",
  "learner.formations.title": "My Courses",
  "learner.formations.searchPlaceholder": "Search a course…",
  "learner.formations.all": "All",
  "learner.formations.formation": "Course",
  "learner.formations.inProgress": "In progress",
  "learner.formations.completed": "Completed",
  "learner.formations.notStarted": "Not started",
  "learner.formations.loading": "Loading your courses...",
  "learner.formations.empty": "No course found.",
  "learner.formations.progress": "Progress",
  "learner.formations.instructor": "Instructor",
  "learner.formations.opening": "Opening...",
  "learner.formations.review": "Review",
  "learner.formations.start": "Start",
  "learner.formations.continue": "Continue",
  "learner.podcasts.title": "Explore Podcasts",
  "learner.podcasts.searchPlaceholder": "Search a podcast…",
  "learner.podcasts.all": "All",
  "learner.podcasts.assigned": "Assigned podcast",
  "learner.podcasts.defaultCategory": "Podcast",
  "learner.podcasts.loading": "Loading your podcasts...",
  "learner.podcasts.empty": "No assigned podcast.",
  "learner.podcasts.episodes": "episodes",
  "learner.podcasts.opening": "Opening...",
  "learner.podcasts.listen": "Listen",
  "learner.documents.title": "My Documents",
  "learner.documents.loading": "Loading your documents...",
  "learner.documents.view": "View document",
  "learner.documents.empty": "No shared document.",
  "learner.progress.title": "My Progress",
  "learner.progress.completedFormations": "Completed courses",
  "learner.progress.trainingHours": "Training hours",
  "learner.progress.listenedPodcasts": "Podcasts listened",
  "learner.progress.earnedBadges": "Badges earned",
  "learner.progress.weeklyActivity": "Weekly activity",
  "learner.progress.badges": "Badges",
  "learner.progress.recentActivity": "Recent activity",
  "learner.progress.rarity.common": "Common",
  "learner.progress.rarity.rare": "Rare",
  "learner.progress.rarity.epic": "Epic",
  "learner.progress.rarity.legendary": "Legendary",
  "learner.progress.days.mon": "Mon",
  "learner.progress.days.tue": "Tue",
  "learner.progress.days.wed": "Wed",
  "learner.progress.days.thu": "Thu",
  "learner.progress.days.fri": "Fri",
  "learner.progress.days.sat": "Sat",
  "learner.progress.days.sun": "Sun",
  "learner.profile.title": "My Profile",
  "learner.profile.defaultName": "Learner",
  "learner.profile.defaultEmail": "learner@example.com",
  "learner.profile.memberSince": "Member since January 2024",
  "learner.profile.editProfile": "Edit profile",
  "learner.profile.formations": "Courses",
  "learner.profile.hours": "Hours",
  "learner.profile.podcasts": "Podcasts",
  "learner.profile.badges": "Badges",
  "learner.profile.preferences": "Preferences",
  "learner.profile.theme": "Theme",
  "learner.profile.themeLight": "Light",
  "learner.profile.themeDark": "Dark",
  "learner.profile.themeSystem": "System",
  "learner.profile.language": "Language",
  "learner.profile.notifications": "Notifications",
  "learner.profile.fontSize": "Text size",
  "learner.profile.fontNormal": "Normal",
  "learner.profile.fontLarge": "Large",
  "learner.profile.highContrast": "High contrast",
  "learner.profile.dangerZone": "Danger zone",
  "learner.profile.logoutBtn": "Log out",
  "learner.parcours.title": "My Paths",
  "learner.parcours.assigned": "assigned path(s)",
  "learner.parcours.loading": "Loading your paths…",
  "learner.parcours.loadError": "Unable to load your paths.",
  "learner.parcours.noAssigned": "No assigned path",
  "learner.parcours.noAssignedDesc": "Your instructor will assign paths here.",
  "learner.parcours.completedBadge": "Completed ✓",
  "learner.parcours.by": "By",
  "learner.parcours.contents": "content(s)",
  "learner.parcours.completedItems": "completed",
  "learner.parcours.emptyPath": "No content in this path.",
  "learner.parcours.locked": "Complete the previous one first",
  "learner.parcours.review": "Review",
  "learner.parcours.listen": "Listen",
  "learner.parcours.open": "Open",
  "learner.modal.loading": "Loading…",
  "learner.modal.noEpisodes": "No episode available.",
  "learner.modal.markedDone": "✓ Marked as done",
  "learner.modal.listenThenMark": "Listen then mark as done",
  "learner.modal.alreadyDone": "Already done",
  "learner.modal.markDone": "Mark as done",
  "learner.modal.formationDone": "✓ Course completed",
  "learner.modal.completeThenMark": "Complete the course then mark it as done",
  "learner.modal.formationAlreadyDone": "Already completed",
  "learner.modal.markFormationDone": "Mark as completed",
  "learner.modal.formationInstruction": "Follow the modules of this course in order, then mark it as completed to progress in your path.",
  "learner.modal.launchFormation": "Launch course",
  "learner.modal.openFormationHint": "Open the course in a new tab, then mark it as completed from your path.",
  "learner.home.loadingHome": "Loading your home…",
  "learner.home.noFormationsAssigned": "No course assigned yet. They will appear here when a trainer assigns one to you.",
  "learner.home.loadingPaths": "Loading your paths…",
  "learner.home.noPathsAssigned": "No path assigned yet. They will appear here when a trainer assigns one to you.",
  "learner.home.byTheme": "Your content by theme",
  "learner.home.themesHint": "Themes come from the categories of your assigned courses and podcasts.",
  "learner.home.categoryOther": "Other",
  "learner.home.contentsCount_one": "{{count}} item",
  "learner.home.contentsCount_other": "{{count}} items",
  "learner.home.resumeSubtitleProgress": "Progress {{percent}}%",
  "learner.home.resumeSubtitleNotStarted": "Not started yet",
  "learner.home.podcastsAssigned": "Assigned podcasts",
  "learner.home.viewAllPodcasts": "See all →",
  "learner.home.gamificationHomeHint": "Badges and full activity are under the « My progress » tab.",
  "learner.home.gamificationHomeCta": "Open my progress",
  "learner.podcasts.mineTitle": "My podcasts",
  "learner.podcasts.episodeCount_one": "{{count}} episode",
  "learner.podcasts.episodeCount_other": "{{count}} episodes",
  "learner.progress.loading": "Loading your progress…",
  "learner.progress.statPodcastsCompleted": "Podcasts completed",
  "learner.progress.statTimeFormationsHours": "Time on courses (h)",
  "learner.progress.statAssignedContents": "Assigned content",
  "learner.progress.weeklyEstimated": "Last 7 days activity (estimated)",
  "learner.progress.badgesSoon": "Badges and rewards will be available in your space soon.",
  "learner.progress.gamificationSection": "Level and experience",
  "learner.progress.gamificationLevelLine": "Level {{level}} — {{name}}",
  "learner.progress.gamificationXpToNext": "{{xp}} XP until the next level",
  "learner.progress.rewardFormation": "Course completed",
  "learner.progress.rewardPathItem": "Learning path step",
  "learner.progress.rewardPathComplete": "Learning path completed",
  "learner.progress.rewardDesignerBlocks": "Course points (completed blocks)",
  "learner.progress.rewardDesignerPerfect": "Perfect quiz score bonus",
  "learner.progress.rewardDesignerBadge": "Course badge",
  "learner.progress.rewardDesignerBadgeNoXp": "No XP points (visual reward)",
  "learner.progress.badgesEmpty": "Complete a course or a learning path to earn points and see your rewards here.",
  "learner.progress.plusXp": "+{{xp}} XP",
  "learner.progress.noRecentHint": "No recent activity yet. Open a course or a podcast to feed this list.",
  "learner.progress.hoursShort": "{{hours}}h",
  "learner.profile.statFormationsRatio": "Courses (completed / total)",
  "learner.profile.statTimeFormations": "Course time (h)",
  "learner.profile.statPodcastsAssigned": "Assigned podcasts",
  "learner.profile.statPathsAssigned": "Assigned paths",
  "learner.profile.memberSincePrefix": "Member since {{date}}",
  "learner.parcours.playPath": "Follow this path",
  "learner.parcours.playPathTitle": "Opens the full-screen path in a new tab",
  "learner.parcours.steps_zero": "No steps",
  "learner.parcours.steps_one": "1 step",
  "learner.parcours.steps_other": "{{count}} steps",
  "learner.parcours.doneBadge": "Done",
  "learner.parcours.completedSingle": "{{done}}/{{total}} completed",
  "learner.parcours.completedPlural": "{{done}}/{{total}} completed",
  "learner.parcours.byAuthor": "By {{firstName}} {{lastName}}",
  "learner.parcours.pathListAria": "Your paths list",
  "learner.parcours.assignedCount_one": "{{count}} assigned path",
  "learner.parcours.assignedCount_other": "{{count}} assigned paths",
  "learner.pathPlayer.loading": "Loading path…",
  "learner.pathPlayer.errorGeneric": "Error",
  "learner.pathPlayer.pathNotFound": "Path not found",
  "learner.pathPlayer.loadError": "Unable to load path.",
  "learner.pathPlayer.backToPaths": "Back to my paths",
  "learner.pathPlayer.showTocAria": "Show outline",
  "learner.pathPlayer.prevActivityAria": "Previous activity",
  "learner.pathPlayer.prev": "Previous",
  "learner.pathPlayer.nextActivityAria": "Next activity",
  "learner.pathPlayer.next": "Next",
  "learner.pathPlayer.closePlayerTitle": "Close and return to paths",
  "learner.pathPlayer.close": "Close",
  "learner.pathPlayer.congrats": "Congratulations",
  "learner.pathPlayer.pathCompleteTitle": "Path completed",
  "learner.pathPlayer.pathCompleteBody": "You have completed all activities in the path “{{title}}”.",
  "learner.pathPlayer.activitiesCompleted_one": "{{count}} activity completed",
  "learner.pathPlayer.activitiesCompleted_other": "{{count}} activities completed",
  "learner.pathPlayer.seeMyPaths": "See my paths",
  "learner.pathPlayer.closeTocAria": "Close outline",
  "learner.pathPlayer.tocNavAria": "Path outline",
  "learner.pathPlayer.pathTypeLabel": "Training path",
  "learner.pathPlayer.noDescription": "No description.",
  "learner.pathPlayer.activityCount_zero": "No activities",
  "learner.pathPlayer.activityCount_one": "1 activity",
  "learner.pathPlayer.activityCount_other": "{{count}} activities",
  "learner.pathPlayer.progressPercent": "Progress {{percent}}%",
  "learner.pathPlayer.quit": "Leave",
  "learner.pathPlayer.summary": "Outline",
  "learner.pathPlayer.outsideModule": "Outside module",
  "learner.pathPlayer.moduleContents": "Module contents",
  "learner.pathPlayer.step": "Step",
  "learner.pathPlayer.podcastHint": "Listen to the episode, then mark the activity as complete.",
  "learner.pathPlayer.showChapters": "Show chapters",
  "learner.pathPlayer.hideChapters": "Hide chapters",
  "learner.pathPlayer.showText": "Show transcript",
  "learner.pathPlayer.hideText": "Hide transcript",
  "learner.pathPlayer.selectEpisode": "Select an episode to start.",
  "learner.pathPlayer.loadingShort": "Loading…",
  "learner.pathPlayer.noEpisodes": "No episodes available.",
  "learner.pathPlayer.listenThenMark": "Listen, then mark as complete",
  "learner.pathPlayer.updating": "Updating…",
  "learner.pathPlayer.alreadyDone": "Already completed",
  "learner.pathPlayer.markComplete": "Mark as complete",
  "learner.pathPlayer.nextStepBtn": "Next step",
  "learner.pathPlayer.embeddedFormationHint": "The course appears below in the path. Use the outline on the left for detailed steps.",
  "learner.pathPlayer.loadingFormation": "Loading course…",
  "learner.pathPlayer.loadingReader": "Loading player…",
  "learner.pathPlayer.emptyPathTitle": "This path does not have any activities yet.",
  "learner.pathPlayer.emptyPathDesc": "Content will be added by your training organization. You can close this window and come back later.",
  "learner.pathPlayer.pickActivity": "Choose an activity in the outline to get started.",
  "learner.pathPlayer.footerStep": "Step {{current}} / {{total}}",
  "learner.pathPlayer.unmute": "Unmute",
  "learner.pathPlayer.mute": "Mute",
  "learner.activity.flowCompleted": "Course “{{title}}” completed",
  "learner.activity.flowProgress": "Course “{{title}}” — {{progress}}%",
  "learner.activity.podcast": "Podcast “{{title}}”",
  "learner.webinars.durationMin": "{{m}} min",
  "learner.webinars.durationH": "{{h}} h",
  "learner.webinars.durationHM": "{{h}} h {{m}}",
  "learner.formations.durationHours": "{{hours}} h",
  "rh.dashboard.title": "HR dashboard",
  "rh.dashboard.subtitle": "Training & development overview",
  "rh.dashboard.activeCampaigns": "Active campaigns",
  "rh.dashboard.pendingAssignmentsKpi": "Assignments (pending / accepted)",
  "rh.dashboard.pendingRequestsCount": "Pending requests",
  "rh.dashboard.completionRateLabel": "Completion rate (learning paths)",
  "rh.dashboard.budgetUsed": "Campaign budget used",
  "rh.dashboard.budgetNotSet": "Not set",
  "rh.dashboard.progressLabel": "Progress (%)",
  "rh.dashboard.chartCampaignsTitle": "Campaign progress",
  "rh.dashboard.chartFormationsTitle": "Learning path progress",
  "rh.dashboard.campaignProgress": "Campaign progress",
  "rh.dashboard.chartCampaignsHint": "Average assignment completion rate per campaign.",
  "rh.dashboard.chartFormationsHint": "Share of learners who completed the path (of current enrollments).",
  "rh.dashboard.upcomingDeadlines": "Upcoming deadlines",
  "rh.dashboard.recentActivity": "Recent activity",
  "rh.dashboard.recentActivityHint": "Campaign assignments and completed paths.",
  "rh.dashboard.viewAll": "View all",
  "rh.dashboard.exportReport": "Export report",
  "rh.dashboard.exportSoon": "Export coming soon.",
  "rh.dashboard.newCampaign": "New campaign",
  "rh.dashboard.createCampaign": "Create campaign",
  "rh.dashboard.reviewRequests": "Review requests",
  "rh.dashboard.skillsMap": "Skills framework",
  "rh.dashboard.budgetOverview": "Budget overview",
  "rh.dashboard.loadError": "Could not load HR dashboard.",
  "rh.dashboard.emptyChart": "No data to display yet.",
  "rh.dashboard.emptyDeadlines": "No upcoming campaign deadlines.",
  "rh.dashboard.emptyRecent": "No recent activity.",
  "rh.dashboard.kindAssignment": "Campaign",
  "rh.dashboard.kindCompletion": "Path completed",
  "rh.dashboard.justNow": "Just now",
  "rh.dashboard.learnerInsightTitle": "Training operations (live data)",
  "rh.dashboard.learnerInsightHint": "Aggregated EduFlow enrollments: scores from graded blocks, block friction, latest evaluations.",
  "rh.dashboard.enrollmentsTotal": "Enrollments",
  "rh.dashboard.completionGlobal": "Completed",
  "rh.dashboard.avgTimePerEnrollment": "Avg. time per enrollment",
  "rh.dashboard.notStarted": "Not started",
  "rh.dashboard.stalled": "Stalled (>30d inactive after start)",
  "rh.dashboard.topFlowsDetail": "Most subscribed paths",
  "rh.dashboard.colFlow": "Path",
  "rh.dashboard.colEnrolled": "Enrolled",
  "rh.dashboard.colCompletedPct": "Completion",
  "rh.dashboard.colAvgTime": "Avg. time",
  "rh.dashboard.colAvgScore": "Avg. score",
  "rh.dashboard.blockFrictionTitle": "Highest-friction blocks (≥3 sessions)",
  "rh.dashboard.colBlock": "Block",
  "rh.dashboard.colSessions": "Sessions",
  "rh.dashboard.colBlockCompletion": "Block completion",
  "rh.dashboard.recentEvalTitle": "Latest evaluations",
  "rh.dashboard.evalComment": "Has comment",
  "rh.dashboard.exportOk": "CSV downloaded.",
  "rh.dashboard.exportFail": "Download failed.",
  "institution.dashboard.trainingCardTitle": "Training follow-up (enrollments)",
  "institution.dashboard.trainingCardHint": "Aggregated across all institution learning paths.",
  "institution.dashboard.trainingCompleted": "paths completed",
  "institution.dashboard.trainingAvgMinutes": "avg min / enrollment",
  "rh.status.urgent": "Urgent",
  "rh.status.soon": "Soon",
  "rh.status.upcoming": "Upcoming",
  "rh.status.pending": "Pending",
  "rh.status.approved": "Approved",
  "rh.status.rejected": "Rejected",
  "admin.nav.stats": "Statistics",
  "admin.nav.users": "Users",
  "admin.nav.support": "Support & chat",
  "admin.nav.institutions": "Institutions",
  "admin.nav.contracts": "Contracts",
  "admin.nav.editors": "Editors",
  "admin.nav.podcasts": "Podcasts",
  "admin.nav.sounds": "Lyrra sounds",
  "admin.nav.templates": "Video templates",
  "admin.nav.templatesImages": "Image templates",
  "admin.nav.tools": "Tools",
  "admin.nav.files": "Files",
  "admin.nav.logs": "Logs",
  "admin.nav.webhooks": "Webhooks",
  "admin.nav.email": "Email",
  "admin.nav.docusign": "DocuSign",
  "admin.docusign.title": "DocuSign integration",
  "admin.docusign.subtitle": "Integration key, API identifiers and RSA private key (JWT). Stored in the database, not in Docker.",
  "admin.docusign.statusOk": "Configured",
  "admin.docusign.statusIncomplete": "Incomplete",
  "admin.docusign.keyStored": "Private key on file",
  "admin.docusign.consentHint": "For first-time JWT use, the DocuSign account must grant application consent (URL from DocuSign). If you get 401/403, check the PEM key, integration key and consent.",
  "admin.docusign.loading": "Loading…",
  "admin.docusign.loadError": "Could not load DocuSign settings",
  "admin.docusign.saved": "DocuSign settings saved",
  "admin.docusign.saveError": "Could not save",
  "admin.docusign.save": "Save",
  "admin.docusign.reload": "Reload",
  "admin.docusign.fieldIntegrationKey": "Integration key (client ID)",
  "admin.docusign.fieldUserId": "User ID (GUID)",
  "admin.docusign.fieldAccountId": "Account ID",
  "admin.docusign.fieldBasePath": "REST API base URL",
  "admin.docusign.fieldOauthHost": "OAuth host (without https://)",
  "admin.docusign.fieldRsa": "RSA private key (PEM)",
  "admin.docusign.oauthPlaceholder": "account-d.docusign.com",
  "admin.docusign.rsaPlaceholderKeep": "Leave empty to keep the current key",
  "admin.docusign.rsaPlaceholderNew": "Paste the full .pem file (BEGIN … END)",
  "admin.smtp.cardTitle": "Outbound email (SMTP)",
  "admin.smtp.subtitle": "Host, port, credentials, and sender. Stored in the database — no Docker SMTP_* or EMAIL_FROM variables.",
  "admin.smtp.host": "SMTP host",
  "admin.smtp.port": "Port",
  "admin.smtp.secure": "TLS/SSL (e.g. port 465)",
  "admin.smtp.user": "Username",
  "admin.smtp.password": "Password",
  "admin.smtp.passwordPlaceholder": "Leave empty to keep the current password",
  "admin.smtp.passwordPlaceholderNew": "SMTP password",
  "admin.smtp.fromEmail": "From email",
  "admin.smtp.fromName": "From display name",
  "admin.smtp.hint": "Most providers require a username and password. Use the admin email test tool after saving.",
  "admin.smtp.save": "Save SMTP",
  "admin.smtp.saved": "SMTP settings saved",
  "admin.smtp.saveError": "Could not save",
  "admin.smtp.loadError": "Could not load SMTP settings",
  "admin.smtp.loading": "Loading…",
  "admin.smtp.configured": "Settings saved",
  "admin.smtp.notConfigured": "Incomplete",
  "admin.nav.smtp": "SMTP configuration",
  "admin.nav.formationMigration": "Course migration",
  "admin.nav.formationDuplicate": "Duplicate courses",
  "admin.formationDuplicate.title": "Duplicate a course to another institution",
  "admin.formationDuplicate.subtitle": "Search for a course, then pick the institution and account that will own the copy. The original course is left unchanged. The copy is a draft (no catalogue, sessions, or collaborators).",
  "admin.formationDuplicate.searchLabel": "Search (title or course ID)",
  "admin.formationDuplicate.searchPlaceholder": "e.g. onboarding or UUID…",
  "admin.formationDuplicate.search": "Search",
  "admin.formationDuplicate.searchMin": "Enter at least 2 characters.",
  "admin.formationDuplicate.results": "Results",
  "admin.formationDuplicate.noResults": "No course found.",
  "admin.formationDuplicate.currentOwner": "Current owner",
  "admin.formationDuplicate.currentInstitution": "Source institution",
  "admin.formationDuplicate.targetInstitution": "Copy destination institution",
  "admin.formationDuplicate.pickInstitution": "Select an institution…",
  "admin.formationDuplicate.newOwner": "Copy owner (trainer / HR)",
  "admin.formationDuplicate.pickOwner": "Select an account…",
  "admin.formationDuplicate.noCandidates": "No eligible account in this institution.",
  "admin.formationDuplicate.duplicate": "Duplicate course",
  "admin.formationDuplicate.confirm": "Create a copy of this course for the selected account? The source course will not be modified.",
  "admin.formationDuplicate.success": "Copy created: \"{{title}}\" for {{email}}. New course ID: {{newFlowId}}.",
  "admin.formationDuplicate.loadInstitutionsError": "Could not load institutions.",
  "admin.formationDuplicate.loadCandidatesError": "Could not load eligible accounts.",
  "admin.formationMigration.title": "Migrate a course between institutions",
  "admin.formationMigration.subtitle": "Search an EduFlow, pick the target institution and an account that can own it (trainer, HR, etc.). Collaborators and course categories are cleared; catalogue links, campaigns and competencies from the previous institution are removed.",
  "admin.formationMigration.searchLabel": "Search (title or course ID)",
  "admin.formationMigration.searchPlaceholder": "e.g. onboarding or UUID…",
  "admin.formationMigration.search": "Search",
  "admin.formationMigration.searchMin": "Enter at least 2 characters.",
  "admin.formationMigration.results": "Results",
  "admin.formationMigration.noResults": "No course found.",
  "admin.formationMigration.currentOwner": "Current owner",
  "admin.formationMigration.currentInstitution": "Source institution",
  "admin.formationMigration.targetInstitution": "Target institution",
  "admin.formationMigration.pickInstitution": "Select an institution…",
  "admin.formationMigration.newOwner": "New owner (trainer / HR)",
  "admin.formationMigration.pickOwner": "Select an account…",
  "admin.formationMigration.noCandidates": "No eligible account in this institution.",
  "admin.formationMigration.migrate": "Migrate course",
  "admin.formationMigration.confirm": "Confirm migration? Collaborators and categories will be cleared; inconsistent HR/catalogue links will be removed.",
  "admin.formationMigration.success": "Done: \"{{title}}\" is now assigned to {{email}}.",
  "admin.formationMigration.clearedCatalog": "Catalogue link removed (item belonged to another institution).",
  "admin.formationMigration.loadInstitutionsError": "Could not load institutions.",
  "admin.formationMigration.loadCandidatesError": "Could not load eligible accounts.",
  "admin.support.title": "Support conversations",
  "admin.support.loadError": "Could not load conversations.",
  "admin.support.replyError": "Could not send the reply.",
  "admin.support.selectThread": "Select a conversation to view messages.",
  "admin.support.replyPlaceholder": "Your reply to the user…",
  "admin.support.sendReply": "Send",
  "admin.support.refresh": "Refresh",
  "admin.support.user": "User",
  "admin.support.subject": "Subject",
  "admin.support.status": "Status",
  "admin.support.priority": "Priority",
  "admin.support.updated": "Updated",
  "admin.support.messages": "Thread",
  "admin.support.newestFirst": "newest first",
  "admin.support.allStatuses": "All statuses",
  "admin.support.linearCreate": "Create Linear issue",
  "admin.support.linearOpen": "Open in Linear",
  "admin.support.linearError": "Could not create the Linear issue. Check LINEAR_API_KEY on the server.",
  "podcasts.list.filterAll": "All",
  "podcasts.list.filterArchived": "Archived",
  "podcasts.list.archivePodcast": "Archive podcast",
  "podcasts.list.restoreFromArchive": "Restore from archive",
  "podcasts.list.archiveSuccess": "Podcast archived",
  "podcasts.list.archiveError": "Could not archive the podcast.",
  "podcasts.list.restoreSuccess": "Podcast restored",
  "podcasts.list.restoreError": "Could not restore the podcast.",
  "podcasts.list.badgeArchived": "Archived",
  "podcasts.list.emptyArchivedNone": "No archived podcasts.",
  "podcasts.list.emptyAllArchived": "All podcasts are archived. Open the « Archived » tab to see them.",
  "share.publicQrTitle": "Public link QR code",
  "share.publicQrError": "Could not generate the QR code.",
  "share.downloadQrPng": "Download as PNG",
  "learningPaths.editor.backToList": "Back to paths",
  "learningPaths.editor.pathNameLabel": "Path name *",
  "learningPaths.editor.idCopyHint": "Path ID (for support)",
  "learningPaths.editor.sectionNavAria": "Path editor sections",
  "learningPaths.editor.tabContents": "Contents",
  "learningPaths.editor.tabLearners": "Learners",
  "webinars.card.exportAttendance": "Download attendance (CSV)",
  "webinars.card.attendanceExportError": "Could not download the attendance file.",
  "webinars.card.publicSignupBadge": "Public signup",
  "webinars.panel.backgroundUrlLabel": "Image address (URL)",
  "webinars.panel.backgroundUploadTitle": "Upload an image (My images)",
  "webinars.panel.backgroundLibraryTitle": "My images",
  "webinars.panel.backgroundLibraryEmpty": "No images yet — upload above or from the Images page in your dashboard.",
  "webinars.panel.backgroundOpenImagesPage": "Open Images page",
  "webinars.panel.backgroundUseDefault": "Use default Lyrra background",
  "webinars.panel.backgroundUploading": "Uploading…",
  "webinars.panel.backgroundUploadError": "Image upload failed.",
  "webinars.panel.publicAccessTitle": "Public signup (form)",
  "webinars.panel.publicAccessHelp": "Participants who are not co-presenters fill in a form after signing in to Lyrra: email, password (they choose it) and any extra fields you add below.",
  "webinars.panel.publicFormFixedFieldsHint": "Email and password (min. 8 characters) are always required for participants; add optional or required extra fields here.",
  "webinars.panel.publicFormAddFieldButton": "Add field",
  "webinars.panel.publicFormFieldNumber": "Field {{n}}",
  "webinars.panel.publicFormFieldLabel": "Label shown",
  "webinars.panel.publicFormFieldType": "Type",
  "webinars.panel.publicFormFieldTypeText": "Short text",
  "webinars.panel.publicFormFieldTypeTextarea": "Long text",
  "webinars.panel.publicFormFieldRequired": "Required",
  "webinars.panel.publicFormFieldRemove": "Remove",
  "webinars.panel.publicFormFieldIdHint": "Technical id:",
  "webinars.panel.publicFormFieldLabelRequired": "Each field must have a label.",
  "webinars.panel.publicAccessLoginLabel": "Signup form login",
  "webinars.panel.publicAccessPasswordLabel": "Signup form password",
  "webinars.panel.publicAccessPasswordPlaceholderNew": "At least 8 characters",
  "webinars.panel.publicAccessPasswordPlaceholderKeep": "Leave blank to keep the current password",
  "webinars.panel.publicAccessPasswordHint": "On create or first activation: password required (min. 8). Later: leave blank to keep the current password.",
  "webinars.panel.publicAccessLoginRequired": "Enter a login for public signup.",
  "webinars.panel.publicAccessPasswordRequired": "Set a password of at least 8 characters.",
  "webinars.panel.publicAccessPasswordMin": "The public password must be at least 8 characters.",
  "videos.card.draft": "Draft",
  "videos.page.studioButton": "Studio",
  "videos.studio.title": "Video studio",
  "videos.studio.rail.prep": "Prep",
  "videos.studio.rail.capture": "Capture",
  "videos.studio.rail.post": "Edit",
  "videos.studio.rail.aria": "Video studio steps",
  "videos.studio.badge.setup": "Setup",
  "videos.studio.badge.capture": "Capture",
  "videos.studio.badge.recording": "Recording",
  "videos.studio.badge.post": "Edit",
  "videos.studio.cannotLeaveRecord": "Stop recording before switching step.",
  "videos.studio.railNeedRecording": "Record a video to open the edit step.",
  "videos.studio.sidebar.captureHelp": "Recording captures the entire shared feed (screen, tab, or window). Cropping to the useful area will be done in the Edit step.",
  "videos.studio.sidebar.sources": "Sources",
  "videos.studio.sidebar.recordingLive": "Recording in progress",
  "videos.studio.sidebar.finalizeHint": "Save to your library using the button in the top bar.",
  "videos.studio.canvas.setupEmpty": "Read the side panel, then go to the Capture step.",
  "videos.studio.stepSetup": "Setup",
  "videos.studio.stepCapture": "Capture",
  "videos.studio.stepPost": "Edit",
  "videos.studio.titleLabel": "Video title",
  "videos.studio.titlePlaceholder": "My recording…",
  "videos.studio.saveSetup": "Continue to capture",
  "videos.studio.fieldDescription": "Description",
  "videos.studio.fieldCategories": "Categories",
  "videos.studio.categoriesHint": "One or more categories from your institution (optional).",
  "videos.studio.categoriesEmptyInstitution": "No categories are set up for your institution.",
  "videos.studio.audioTrackPlanned": "Planned audio track",
  "videos.studio.voiceHumanPlan": "Human voice (recorded microphone)",
  "videos.studio.voiceAiPlan": "AI voice (choose for the edit step)",
  "videos.studio.postVoiceHumanKeep": "You chose human voice: the video keeps the microphone audio. Finalize when you are ready.",
  "videos.studio.titleUntitled": "Untitled",
  "videos.studio.voiceAiNoVoices": "No AI voices are available right now.",
  "videos.studio.postVoiceAiPipeline": "AI voice: polish the text, generate the audio track, then apply it to the video.",
  "videos.studio.allowMedia": "Allow screen and microphone",
  "videos.studio.controlsHint": "Tip: to avoid recording this bar, share a tab or a window instead of the full screen, or use a second display. Space = pause / resume when this page is focused.",
  "videos.studio.warnTabOnly": "You selected a single tab: only that tab will be recorded, even if you open other tabs. To capture multiple tabs or windows, restart capture and choose \"Entire Screen\".",
  "videos.studio.templateMenuTitle": "Templates menu",
  "videos.studio.templateEmpty": "No saved template",
  "videos.studio.templatesHintCompact": "Click + to save, apply, or delete a template.",
  "videos.studio.overlayAddMusic": "Background music",
  "videos.studio.musicInvalidType": "Invalid format. Use an audio file (MP3, WAV, M4A, OGG).",
  "videos.studio.musicTooLarge": "Audio file must not exceed 50 MB.",
  "videos.studio.musicDefault": "Music",
  "videos.studio.musicAdded": "Background music added to timeline.",
  "videos.studio.musicUploadError": "Unable to add background music.",
  "videos.studio.layerScreenBorder": "Outer border",
  "videos.studio.layerScreenBorderSize": "Size",
  "videos.studio.layerScreenBorderColor": "Color",
  "videos.studio.layerScreenBorderRadius": "Corner radius",
  "videos.studio.segmentToolsTitle": "Segment tools",
  "videos.studio.segmentZoom": "Zoom",
  "videos.studio.segmentResetView": "Reset view",
  "videos.studio.segmentTransition": "Transition",
  "videos.studio.transitionNone": "None",
  "videos.studio.transitionFade": "Fade",
  "videos.studio.transitionWipeLeft": "Wipe →",
  "videos.studio.transitionSlideUp": "Slide ↑",
  "videos.studio.textEditor.toolbar": "Text formatting",
  "videos.studio.textEditor.bold": "Bold",
  "videos.studio.textEditor.italic": "Italic",
  "videos.studio.textEditor.underline": "Underline",
  "videos.studio.textEditor.textColor": "Text color (selection)",
  "videos.studio.textEditor.size": "Size",
  "videos.studio.textEditor.font": "Font",
  "videos.studio.textEditor.fontFamily.system": "System",
  "videos.studio.textEditor.fontFamily.sansInter": "Sans (Inter)",
  "videos.studio.textEditor.fontFamily.serif": "Serif",
  "videos.studio.textEditor.fontFamily.mono": "Mono",
  "videos.studio.textEditor.fontFamily.script": "Script",
  "videos.studio.controlsHintTab": "You are sharing another tab: the recording does not include this Studio page (so these buttons are not in the video). Keep Studio open in another browser window or on a second screen next to your content. For Pause, Stop, or Done, switch to the window where Studio is open (Alt+Tab or Cmd+Tab). Space only works when the Studio page is focused.",
  "videos.studio.controlsHintMonitor": "You are sharing the full screen: this bar may appear in the recording. Prefer sharing a Tab or Window, or move the controls to another monitor.",
  "videos.studio.controlsHintWindow": "You are sharing one window: the rest of the desktop (and other windows) is usually not recorded. Use the buttons below for Pause, Stop, or Done.",
  "videos.studio.startRecord": "Record",
  "videos.studio.pause": "Pause",
  "videos.studio.resume": "Resume",
  "videos.studio.stop": "Stop",
  "videos.studio.terminer": "Done",
  "videos.studio.processingUpload": "Uploading and transcribing…",
  "videos.studio.timeline": "Playback",
  "videos.studio.transcript": "Recognized text",
  "videos.studio.transcriptRefining": "Refining transcription…",
  "videos.studio.transcriptPlaceholder": "Recognized text from your recording will appear here…",
  "videos.studio.voiceMode": "Audio track",
  "videos.studio.voiceOriginal": "My voice (recorded mic)",
  "videos.studio.voiceAi": "AI voice (Mistral TTS)",
  "videos.studio.voiceSelect": "Voice",
  "videos.studio.polish": "Prepare text for AI voice",
  "videos.studio.generateTts": "Generate voiceover",
  "videos.studio.applyVoiceover": "Apply AI voice to video",
  "videos.studio.preview": "Preview",
  "videos.studio.preview.noFile": "No video file to preview.",
  "videos.studio.bgImage": "Background image",
  "videos.studio.bgImageChoose": "Choose",
  "videos.studio.bgImageInvalidType": "Invalid format. Use an image (PNG, JPG, WebP).",
  "videos.studio.bgImageTooLarge": "Image must not exceed 10 MB.",
  "videos.studio.bgImageLoadError": "Could not load the background image.",
  "videos.studio.bgImageUploading": "Uploading…",
  "videos.studio.bgImageUploadError": "Could not upload the image. Try again.",
  "videos.studio.bgImageLibraryTitle": "Video studio background",
  "videos.studio.postLayoutTitle": "Frame & background",
  "videos.studio.postLayoutHint": "Preview matches the published video: save the draft then publish to apply background, size, and position.",
  "videos.studio.bgImageVideoSize": "Video size",
  "videos.studio.dragToMove": "Drag to move",
  "videos.studio.finalize": "Save to library",
  "videos.studio.saveDraft": "Draft",
  "videos.studio.publish": "Publish",
  "videos.studio.successDraft": "Video saved as draft",
  "videos.studio.successPublish": "Video published to your library",
  "videos.studio.processingPublish": "Processing video…",
  "videos.studio.back": "Back to videos",
  "videos.studio.errorMedia": "Could not access screen or microphone.",
  "videos.studio.errorInsecureContext": "Screen capture requires HTTPS or localhost. Open the app via https:// or http://127.0.0.1 / localhost.",
  "videos.studio.errorNotSupported": "This browser or device does not support screen capture here. Use an up-to-date Chrome or Edge on desktop.",
  "videos.studio.errorMicDenied": "Microphone blocked: allow microphone for this site (lock or info icon in the address bar), then try again.",
  "videos.studio.errorScreenDenied": "Screen sharing denied: pick a screen or tab in the browser dialog and confirm « Share ».",
  "videos.studio.errorMicMissing": "No microphone found. Check hardware and system settings.",
  "videos.studio.errorScreenMissing": "Screen sharing is not available on this device or browser.",
  "videos.studio.errorMicBusy": "Microphone is in use by another app. Close it and try again.",
  "videos.studio.errorScreenBusy": "Could not capture the screen (resource busy). Retry or restart the browser.",
  "videos.studio.errorScreenCancelled": "Screen sharing cancelled.",
  "videos.studio.errorMicCancelled": "Microphone access cancelled.",
  "videos.studio.errorMicGeneric": "Could not access the microphone.",
  "videos.studio.errorScreenGeneric": "Could not capture the screen.",
  "videos.studio.errorScreenEnded": "Screen sharing stopped.",
  "videos.studio.mediaHints": "Chrome or Edge on desktop. If you use http:// with a LAN IP (e.g. 192.168.x.x), capture is often blocked: use http://localhost:5173 or valid HTTPS.",
  "videos.studio.errorRecord": "Recording is not supported in this browser.",
  "videos.studio.errorUpload": "Upload failed.",
  "videos.studio.errorLoadDraft": "Could not load draft.",
  "videos.studio.errorTranscribe": "Transcription unavailable.",
  "videos.studio.errorPolish": "AI polish failed.",
  "videos.studio.errorTts": "Text-to-speech failed.",
  "videos.studio.errorMux": "Audio merge failed.",
  "videos.studio.muxSuccess": "AI voice applied to the video",
  "videos.studio.successFinal": "Video saved to your library",
  "videos.studio.generatingTimeline": "Generating timeline…",
  "videos.studio.crop": "Crop",
  "videos.studio.cropReset": "Reset crop",
  "videos.studio.cropActive": "Crop active — drag or resize the region on the video",
  "videos.studio.cropDone": "Done",
  "videos.studio.cropApplied": "Crop applied",
  "videos.studio.cropEdit": "Edit",
  "videos.studio.cropRemove": "Remove",
  "videos.studio.trimIn": "IN",
  "videos.studio.trimOut": "OUT",
  "videos.studio.trimDuration": "duration",
  "pages.images.copyUrlSuccess": "URL copied to clipboard.",
  "pages.images.copyUrlError": "Could not copy the URL.",
  "pages.images.urlLabel": "Public URL",
  "pages.images.download": "Download",
  "pages.images.downloadSuccess": "Download started.",
  "pages.images.downloadError": "Download failed.",
  "pages.images.viewGrid": "Grid",
  "pages.images.viewList": "List",
  "pages.images.editPanelTitle": "Edit image",
  "pages.images.editPanelSubtitle": "Title, description and file name. Replacing the file keeps the same URL (existing references keep working).",
  "pages.images.replaceFileLabel": "New image file",
  "pages.images.replaceFileHint": "The image is converted to match the current file extension. The public URL does not change.",
  "pages.images.fileOriginalNameLabel": "Original file name",
  "pages.images.saveChanges": "Save",
  "pages.images.saveSuccess": "Image updated.",
  "pages.images.saveError": "Could not save.",
  "pages.images.editAction": "Edit",
  "admin.dashboard.activeToday": "Active today",
  "admin.dashboard.quickActions": "Quick actions",
  "admin.header.workspace": "Platform administration",
  "player.manualVoiceoverMic": "Record voice-over for this language",
  "player.manualVoiceoverStudioTitle": "Voice-over recording studio",
  "player.manualVoiceoverStudioLang": "Recording language",
  "player.manualVoiceoverRecord": "Record",
  "player.manualVoiceoverStop": "Stop",
  "player.manualVoiceoverPlay": "Listen",
  "player.manualVoiceoverSave": "Save to block",
  "player.manualVoiceoverClose": "Close",
  "player.manualVoiceoverHint": "On the right: block text or image in the selected language. Record, then save to attach the audio to this language.",
  "player.manualVoiceoverPreviewLoading": "Loading content…",
  "player.manualVoiceoverNoMic": "Microphone or recording is not available in this browser.",
  "player.manualVoiceoverNoText": "No description text long enough for this block.",
  "player.manualVoiceoverSaveError": "Could not save the voice-over to the block.",
  "player.manualVoiceoverUploadError": "Audio upload failed.",
  "player.manualVoiceoverSaved": "Voice-over saved to the block.",
  "rh.auditDateUnknown": "Not set",
  "rh.auditScheduleHint": "Set in institution settings",
  "rh.compliance": "Compliance",
  "rh.complianceAuditAction.qualiopi_corrective_action_create": "Qualiopi corrective action created",
  "rh.complianceAuditAction.qualiopi_corrective_action_delete": "Qualiopi corrective action deleted",
  "rh.complianceAuditAction.qualiopi_corrective_action_update": "Qualiopi corrective action updated",
  "rh.complianceAuditAction.qualiopi_evidence_create": "Qualiopi evidence added",
  "rh.complianceAuditAction.qualiopi_indicator_update": "Qualiopi indicator updated",
  "rh.compliancePage.tabs.difficulty": "Learning difficulties",
  "rh.compliancePage.tabs.handicap": "Disability liaison",
  "rh.compliancePage.tabs.learnerBilan": "Learner summary",
  "rh.compliancePage.tabs.regulatory": "Regulatory watch",
  "rh.regulatoryWatch.lyrraBadge": "Lyrra Studio",
  "rh.regulatoryWatch.ofResponse": "Our response / position",
  "rh.regulatoryWatch.ofResponsePlaceholder": "What we did or plan to do…",
  "rh.regulatoryWatch.ackStatus": "Status",
  "rh.regulatoryWatch.ack.pending": "To process",
  "rh.regulatoryWatch.ack.read": "Acknowledged (read)",
  "rh.regulatoryWatch.ack.actionTaken": "Action taken",
  "rh.regulatoryWatch.ack.notApplicable": "Not applicable",
  "rh.regulatoryWatch.pdf.title": "Regulatory watch register",
  "rh.regulatoryWatch.pdf.subtitleFallback": "Institution",
  "rh.regulatoryWatch.pdf.generatedAt": "Generated on {{date}}",
  "rh.regulatoryWatch.pdf.colDate": "Date",
  "rh.regulatoryWatch.pdf.colCategory": "Cat.",
  "rh.regulatoryWatch.pdf.colTitle": "Title",
  "rh.regulatoryWatch.pdf.colDesc": "Description (excerpt)",
  "rh.regulatoryWatch.pdf.colImpact": "Impact",
  "rh.regulatoryWatch.pdf.colOrigin": "Origin",
  "rh.regulatoryWatch.pdf.colStatus": "Status",
  "rh.regulatoryWatch.pdf.colAction": "Action",
  "rh.regulatoryWatch.pdf.colWho": "User",
  "rh.regulatoryWatch.pdf.colWhen": "Timestamp",
  "rh.regulatoryWatch.pdf.originLyrra": "Lyrra Studio",
  "rh.regulatoryWatch.pdf.originOf": "Training org.",
  "rh.regulatoryWatch.pdf.readYes": "Read",
  "rh.regulatoryWatch.pdf.readNo": "Unread",
  "rh.regulatoryWatch.pdf.actionDone": "Action done",
  "rh.regulatoryWatch.pdf.actionOpen": "Action in progress",
  "rh.regulatoryWatch.pdf.emptyWatch": "No items recorded",
  "rh.regulatoryWatch.pdf.auditSection": "Internal audit log",
  "rh.regulatoryWatch.pdf.auditHint": "Actions recorded automatically by the platform.",
  "rh.regulatoryWatch.pdf.emptyAudit": "No recent events",
  "rh.regulatoryWatch.exportPdf": "Export PDF",
  "rh.regulatoryWatch.exportPdfBusy": "Exporting PDF…",
  "rh.regulatoryWatch.exportPdfError": "PDF export failed",
  "rh.compliancePage.tabs.satisfaction": "Satisfaction",
  "rh.qualiopiEmpty": "No Qualiopi data available for this institution.",
  "rh.qualiopiLoading": "Loading Qualiopi reference data…",
  "v2.compliance": "Compliance & Qualiopi",
  "designer.validation.formFieldRefsMissing": "« {{title}} »: reference(s) to missing form field(s): {{refs}}.",
  "designer.validation.formFieldRefsOrder": "« {{title}} »: invalid form field variable(s) {{refs}} — the form block must be reached before this block in the flow.",
  "designer.confirmDeleteForm.title": "Delete this form block?",
  "designer.confirmDeleteForm.message": "Other blocks may reference its fields as /fieldId/. Those references will break. You can undo with ⌘Z or Ctrl+Z.",
  "designer.confirmDeleteForm.batchTitle": "Delete selection?",
  "designer.confirmDeleteForm.batchMessage": "The selection includes at least one form block. Slash references elsewhere may break. You can undo with ⌘Z or Ctrl+Z.",
  "voicePanel.multiLangHint": "For one Mistral voice per UI language (all 10), open the Translation panel (languages icon in the designer toolbar).",
  "episodeEditor.block.source": "Source",
  "episodeEditor.block.sourceTts": "IA",
  "episodeEditor.block.sourceMic": "Micro",
  "episodeEditor.block.record": "Enregistrer",
  "episodeEditor.block.stopRecording": "Arrêter",
  "episodeEditor.block.microMode": "Mode micro pour ce bloc",
  "episodeEditor.block.notesRecordingPlaceholder": "Notes optionnelles (non lues automatiquement en micro)",
  "episodeEditor.block.removeRecording": "Supprimer audio",
  "episodeEditor.edit.audioMixedHumanAndAi": "Piste IA + voix micro",
  "episodeEditor.errors.addTextOrRecording": "Ajoutez du texte (synthèse IA) ou enregistrez votre voix sur au moins un bloc avant de générer l'audio.",
  "episodeEditor.errors.saveDraftBeforeRecording": "Impossible de créer l’épisode pour le micro. Ajoutez un titre ou enregistrez depuis un épisode existant.",
  "episodeEditor.errors.microNotSupported": "Micro non disponible dans ce navigateur.",
  "episodeEditor.errors.microPermission": "Impossible d’accéder au micro (permission refusée).",
  "episodeEditor.errors.recordingUploadFailed": "Échec de l’upload de l’enregistrement.",
  "eduflow.designer.toast.flowPastedFromClipboard": "Course created from clipboard",
  "eduflow.designer.toast.exportFailed": "Export failed.",
  "eduflow.designer.toast.importPackageFailed": "Could not import the .lyrra package.",
  "a11y.skipToPlayerMain": "Skip to course content",
  "a11y.playerMainLandmark": "Course content",
  "a11y.dialog": "Dialog",
  "a11y.closeDialog": "Close dialog",
  "a11y.dismissNotification": "Dismiss notification",
  "a11y.notificationsRegion": "Notifications",
  "a11y.skipLinksLandmark": "Quick access links",
  "eduflow.blockEditor.audio.estimatedSeconds": "~{{sec}}s estimated",
  "eduflow.blockEditor.audio.fileLabel": "Audio file",
  "eduflow.blockEditor.audio.formatsHint": "MP3, WAV, OGG",
  "eduflow.blockEditor.audio.generateButton": "Generate audio",
  "eduflow.blockEditor.audio.generateTts": "Generate TTS",
  "eduflow.blockEditor.audio.import": "Import",
  "eduflow.blockEditor.audio.langDe": "German",
  "eduflow.blockEditor.audio.langEn": "English",
  "eduflow.blockEditor.audio.langEs": "Spanish",
  "eduflow.blockEditor.audio.langFr": "French",
  "eduflow.blockEditor.audio.langIt": "Italian",
  "eduflow.blockEditor.audio.language": "Language",
  "eduflow.blockEditor.audio.mistralVoice": "Voice (Mistral TTS)",
  "eduflow.blockEditor.audio.mistralVoicePlaceholder": "Mistral voice ID (Mistral console / API)",
  "eduflow.blockEditor.audio.voicesLoading": "Завантаження голосів…",
  "eduflow.blockEditor.audio.voicesLoadError": "Не вдалося завантажити голоси Mistral.",
  "eduflow.blockEditor.audio.voicesEmptyHint":
    "API не повернув жодного голосу. Перевірте ключ Mistral (Адміністрування → Інтеграції). Синтез усе одно використовує голос за замовчуванням.",
  "eduflow.blockEditor.audio.voiceFallbackOption": "{{id}} (за замовчуванням)",
  "eduflow.blockEditor.audio.generating": "Генерація…",
  "eduflow.blockEditor.audio.generateNeedText": "Спочатку введіть текст для синтезу.",
  "eduflow.blockEditor.audio.generateBadResponse": "Некоректна відповідь TTS.",
  "eduflow.blockEditor.audio.generateSuccess": "Аудіо створено.",
  "eduflow.blockEditor.audio.generateError": "Синтез неможливий (Mistral TTS / інтеграції).",
  "eduflow.blockEditor.audio.preview": "Preview",
  "eduflow.blockEditor.audio.source": "Audio source",
  "eduflow.blockEditor.audio.speedLabel": "Speed: {{speed}}x",
  "eduflow.blockEditor.audio.syncWithText": "Sync with text (subtitles)",
  "eduflow.blockEditor.audio.ttsPlaceholder": "Enter the text to be read by the synthetic voice…",
  "eduflow.blockEditor.audio.ttsText": "Text to synthesize",
  "eduflow.blockEditor.audio.urlLabel": "Or audio file URL",
  "eduflow.blockEditor.audio.urlPlaceholder": "https://example.com/audio.mp3",
  "eduflow.blockEditor.browser.allowExternalAria": "Allow other websites",
  "eduflow.blockEditor.browser.allowExternalHelp": "{{off}}: protected iframe (sandbox) — limits pop-ups and outgoing behavior. {{on}}: better compatibility with rich pages (videos, widgets); navigation possible inside the frame.",
  "eduflow.blockEditor.browser.allowExternalOff": "Off",
  "eduflow.blockEditor.browser.allowExternalOn": "On",
  "eduflow.blockEditor.browser.allowExternalTitle": "Allow other websites",
  "eduflow.blockEditor.browser.frameTitleFallback": "Embedded web page",
  "eduflow.blockEditor.browser.fullscreen": "Fullscreen",
  "eduflow.blockEditor.browser.fullscreenTitle": "Preview — Embedded web page",
  "eduflow.blockEditor.browser.openTab": "Open in a tab",
  "eduflow.blockEditor.browser.preview": "Preview",
  "eduflow.blockEditor.browser.urlHelp": "Enter the full address (https). Preview is framed like a window — this is not a browser: learners cannot change the URL here.",
  "eduflow.blockEditor.browser.urlLabel": "Page URL",
  "eduflow.blockEditor.browser.urlPlaceholder": "https://…",
  "eduflow.blockEditor.chart.addLabel": "Label",
  "eduflow.blockEditor.chart.addSeries": "Series",
  "eduflow.blockEditor.chart.animation": "Animation",
  "eduflow.blockEditor.chart.chartTitle": "Chart title",
  "eduflow.blockEditor.chart.chartType": "Chart type",
  "eduflow.blockEditor.chart.colorTitle": "Color",
  "eduflow.blockEditor.chart.datasets": "Data series ({{count}})",
  "eduflow.blockEditor.chart.defaultLabel": "Label {{n}}",
  "eduflow.blockEditor.chart.defaultSeries": "Series {{n}}",
  "eduflow.blockEditor.chart.interactive": "Interactive (tooltips)",
  "eduflow.blockEditor.chart.labelsX": "Labels (X axis)",
  "eduflow.blockEditor.chart.noSeries": "No series. Click “Series” to add one.",
  "eduflow.blockEditor.chart.readerPreviewHint": "Preview available in player mode",
  "eduflow.blockEditor.chart.seriesNamePlaceholder": "Series name",
  "eduflow.blockEditor.chart.settings": "Settings",
  "eduflow.blockEditor.chart.showGrid": "Show grid",
  "eduflow.blockEditor.chart.showLegend": "Show legend",
  "eduflow.blockEditor.chart.titlePlaceholder": "Optional title",
  "eduflow.blockEditor.chart.typeArea": "Area",
  "eduflow.blockEditor.chart.typeBar": "Bars",
  "eduflow.blockEditor.chart.typeDoughnut": "Doughnut",
  "eduflow.blockEditor.chart.typeLine": "Line",
  "eduflow.blockEditor.chart.typePie": "Pie",
  "eduflow.blockEditor.chart.typeRadar": "Radar",
  "eduflow.blockEditor.evaluation.aiQuestions": "Generate questions with AI",
  "eduflow.blockEditor.evaluation.editFullscreen": "Edit form (fullscreen)",
  "eduflow.blockEditor.evaluation.hint": "Open the fullscreen editor to build the form: drag field types from the left column and reorder questions with the handle.",
  "eduflow.blockEditor.evaluation.metaLine": "{{qPart}} · {{pPart}} total",
  "eduflow.blockEditor.evaluation.pointPlural": "points",
  "eduflow.blockEditor.evaluation.pointSingular": "point",
  "eduflow.blockEditor.evaluation.questionPlural": "questions",
  "eduflow.blockEditor.evaluation.questionSingular": "question",
  "eduflow.blockEditor.evaluation.title": "Assessment form",
  "eduflow.blockEditor.evaluationForm.addFreeText": "Add free text",
  "eduflow.blockEditor.evaluationForm.addOption": "Option",
  "eduflow.blockEditor.evaluationForm.close": "Close",
  "eduflow.blockEditor.evaluationForm.delete": "Delete",
  "eduflow.blockEditor.evaluationForm.dropEmptyHint": "Drop a question type from the left panel here, or use the “Add” button.",
  "eduflow.blockEditor.evaluationForm.escapeHint": "Esc to close",
  "eduflow.blockEditor.evaluationForm.expectedValue": "Expected value",
  "eduflow.blockEditor.evaluationForm.footerStats": "{{n}} question(s) · {{pts}} pts total",
  "eduflow.blockEditor.evaluationForm.headerSubtitle": "Drag a question type from the left into the center. Reorder with the ⋮⋮ handle.",
  "eduflow.blockEditor.evaluationForm.headerTitle": "Assessment form editor",
  "eduflow.blockEditor.evaluationForm.maxAttempts": "Max attempts",
  "eduflow.blockEditor.evaluationForm.moveQuestion": "Move question",
  "eduflow.blockEditor.evaluationForm.optionPlaceholder": "Option…",
  "eduflow.blockEditor.evaluationForm.optionsHint": "Click the icon to mark the correct answer(s).",
  "eduflow.blockEditor.evaluationForm.overlayUntitled": "(untitled)",
  "eduflow.blockEditor.evaluationForm.paletteSubtitle": "Drop on the canvas to add a question.",
  "eduflow.blockEditor.evaluationForm.paletteTitle": "Fields",
  "eduflow.blockEditor.evaluationForm.passThreshold": "Pass threshold: {{pct}}%",
  "eduflow.blockEditor.evaluationForm.pointsShort": "pts",
  "eduflow.blockEditor.evaluationForm.qTypeDropdown": "Dropdown",
  "eduflow.blockEditor.evaluationForm.qTypeFile": "File",
  "eduflow.blockEditor.evaluationForm.qTypeMultiple": "Multiple choice",
  "eduflow.blockEditor.evaluationForm.qTypeNumeric": "Numeric",
  "eduflow.blockEditor.evaluationForm.qTypeSingle": "Single choice",
  "eduflow.blockEditor.evaluationForm.qTypeText": "Free text",
  "eduflow.blockEditor.evaluationForm.questionTitlePlaceholder": "Question title…",
  "eduflow.blockEditor.evaluationForm.refAnswerLabel": "Reference answer (optional)",
  "eduflow.blockEditor.evaluationForm.refAnswerPlaceholder": "Expected answer…",
  "eduflow.blockEditor.evaluationForm.refEmptyHint": "Without reference: any non-empty answer is accepted.",
  "eduflow.blockEditor.evaluationForm.required": "Req.",
  "eduflow.blockEditor.evaluationForm.semanticGrading": "AI grading (semantic similarity)",
  "eduflow.blockEditor.evaluationForm.semanticThreshold": "Semantic threshold: {{pct}}%",
  "eduflow.blockEditor.evaluationForm.showCorrect": "Show correct answers",
  "eduflow.blockEditor.evaluationForm.showResults": "Show results",
  "eduflow.blockEditor.evaluationForm.timeLimit": "Time limit",
  "eduflow.blockEditor.evaluationForm.tolerance": "Tolerance ±",
  "eduflow.blockEditor.glossary.add": "Add",
  "eduflow.blockEditor.glossary.categories": "Categories",
  "eduflow.blockEditor.glossary.definitionPlaceholder": "Definition",
  "eduflow.blockEditor.glossary.description": "Description",
  "eduflow.blockEditor.glossary.descriptionPlaceholder": "Help text for vocabulary…",
  "eduflow.blockEditor.glossary.enableQuiz": "Enable built-in quiz",
  "eduflow.blockEditor.glossary.includeInQuiz": "Include in quiz",
  "eduflow.blockEditor.glossary.newCategoryPlaceholder": "New category",
  "eduflow.blockEditor.glossary.noCategory": "No category",
  "eduflow.blockEditor.glossary.panelHint": "Define your terms and enable quiz mode for review.",
  "eduflow.blockEditor.glossary.panelTitle": "Glossary + built-in quiz",
  "eduflow.blockEditor.glossary.termPlaceholder": "Term",
  "eduflow.blockEditor.glossary.termSingular": "Term",
  "eduflow.blockEditor.glossary.termsCount": "Terms ({{count}})",
  "eduflow.blockEditor.glossary.titleLabel": "Glossary title",
  "eduflow.blockEditor.glossary.titlePlaceholder": "Glossary",
  "eduflow.blockEditor.htmlSource.formatButton": "Format",
  "eduflow.blockEditor.htmlSource.formatTitle": "Re-indent and structure HTML (same logic as when entering code mode)",
  "eduflow.blockEditor.htmlSource.findVerb": "find",
  "eduflow.blockEditor.htmlSource.indentVerb": "indents",
  "eduflow.blockEditor.htmlSource.modeLabel": "HTML code mode",
  "eduflow.blockEditor.mindmap.addChild": "Child node",
  "eduflow.blockEditor.mindmap.addMainBranch": "Add a main branch",
  "eduflow.blockEditor.mindmap.branchTitle": "Branch · {{title}}",
  "eduflow.blockEditor.mindmap.centralTheme": "Central theme",
  "eduflow.blockEditor.mindmap.close": "Close",
  "eduflow.blockEditor.mindmap.configureFullscreen": "Configure fullscreen",
  "eduflow.blockEditor.mindmap.descriptionLabel": "Description",
  "eduflow.blockEditor.mindmap.descriptionPlaceholder": "Supporting text",
  "eduflow.blockEditor.mindmap.dialogTitle": "Mind map",
  "eduflow.blockEditor.mindmap.optional": "Optional",
  "eduflow.blockEditor.mindmap.playerHint": "Player: horizontal map (text on colored curve, pills). Zoom in the block header. URL: ↗ opens a new tab.",
  "eduflow.blockEditor.mindmap.remove": "Remove",
  "eduflow.blockEditor.mindmap.structure": "Structure",
  "eduflow.blockEditor.mindmap.subtitleLabel": "Subtitle",
  "eduflow.blockEditor.mindmap.titleLabel": "Title",
  "eduflow.blockEditor.mindmap.titlePlaceholder": "Node title",
  "eduflow.blockEditor.mindmap.untitled": "Untitled",
  "eduflow.blockEditor.mindmap.urlLabel": "URL link",
  "eduflow.blockEditor.mindmap.urlPlaceholder": "https://…",
  "eduflow.blockEditor.pdf.allowDownload": "Allow download",
  "eduflow.blockEditor.pdf.badgePdf": "PDF",
  "eduflow.blockEditor.pdf.completionLabel": "Completion label",
  "eduflow.blockEditor.pdf.completionPlaceholder": "Document viewed",
  "eduflow.blockEditor.pdf.documentFallback": "PDF document",
  "eduflow.blockEditor.pdf.emptyLibrary": "No documents in your library.",
  "eduflow.blockEditor.pdf.focusMode": "Document focus",
  "eduflow.blockEditor.pdf.focusModeDesc": "Minimal chrome, centered reading",
  "eduflow.blockEditor.pdf.importFailed": "Import failed",
  "eduflow.blockEditor.pdf.importFailedGeneric": "Import failed.",
  "eduflow.blockEditor.pdf.importSubtitle": "The document will be added to your document library.",
  "eduflow.blockEditor.pdf.importTitle": "Import a PDF",
  "eduflow.blockEditor.pdf.librarySubtitle": "Upload a PDF to your library or pick an existing one.",
  "eduflow.blockEditor.pdf.libraryTitle": "Document library",
  "eduflow.blockEditor.pdf.loadingDocs": "Loading documents…",
  "eduflow.blockEditor.pdf.myDocuments": "My documents",
  "eduflow.blockEditor.pdf.pagesAuto": "The player will detect the number of pages automatically.",
  "eduflow.blockEditor.pdf.pagesDetected": "{{count}} pages detected",
  "eduflow.blockEditor.pdf.pickFromLibrary": "Select a PDF already in your library.",
  "eduflow.blockEditor.pdf.previewTitle": "Document preview",
  "eduflow.blockEditor.pdf.readerMode": "Modern reader",
  "eduflow.blockEditor.pdf.readerModeDesc": "Page by page, zoom, fullscreen",
  "eduflow.blockEditor.pdf.readingExperience": "Reading experience",
  "eduflow.blockEditor.pdf.showProgress": "Show reading progress",
  "eduflow.blockEditor.pdf.smartExtractSoon": "Smart extraction coming soon",
  "eduflow.blockEditor.pdf.startPage": "Start page",
  "eduflow.blockEditor.pdf.uploadedDesc": "{{name}} is now available in your document library.",
  "eduflow.blockEditor.pdf.uploadedToast": "PDF imported",
  "eduflow.blockEditor.pdf.uploading": "Upload in progress",
  "eduflow.blockEditor.phraseReveal.addPhrase": "Add a phrase",
  "eduflow.blockEditor.phraseReveal.aiSummaryTitle": "Generate an AI recap from upstream blocks",
  "eduflow.blockEditor.phraseReveal.autoScroll": "Auto-scroll",
  "eduflow.blockEditor.phraseReveal.displayDuration": "Duration per phrase (s)",
  "eduflow.blockEditor.phraseReveal.editorHint": "Add one or more phrases with the rich text editor. The player shows one phrase at a time; click or Space for the next.",
  "eduflow.blockEditor.phraseReveal.emptyPhrase": "Empty phrase",
  "eduflow.blockEditor.phraseReveal.importLegacy": "Import the legacy “text to reveal” field as phrases (recommended).",
  "eduflow.blockEditor.phraseReveal.noPhrases": "No phrases yet.",
  "eduflow.blockEditor.phraseReveal.phraseContent": "Phrase content",
  "eduflow.blockEditor.phraseReveal.phrasePlaceholder": "Enter this step's text…",
  "eduflow.blockEditor.phraseReveal.showHistory": "Show phrase history",
  "eduflow.blockEditor.phraseReveal.showHistoryHelp": "Previously seen phrases appear in a card between the current phrase and the block description.",
  "eduflow.blockEditor.presentation.addSlide": "Slide",
  "eduflow.blockEditor.presentation.autoAdvance": "Auto-advance",
  "eduflow.blockEditor.presentation.delayLabel": "Delay: {{sec}}s",
  "eduflow.blockEditor.presentation.duplicateTitleSuffix": " (copy)",
  "eduflow.blockEditor.presentation.globalSettings": "Global settings",
  "eduflow.blockEditor.presentation.layoutImageText": "Image + text",
  "eduflow.blockEditor.presentation.layoutTitleContent": "Title + content",
  "eduflow.blockEditor.presentation.layoutTitleOnly": "Title only",
  "eduflow.blockEditor.presentation.layoutTwoCol": "Two columns",
  "eduflow.blockEditor.presentation.layoutVideoOnly": "Video only",
  "eduflow.blockEditor.presentation.layoutVideoText": "Text + video",
  "eduflow.blockEditor.presentation.loop": "Loop",
  "eduflow.blockEditor.presentation.noSlides": "No slides. Click to add one.",
  "eduflow.blockEditor.presentation.slideCount_one": "{{count}} slide",
  "eduflow.blockEditor.presentation.slideCount_other": "{{count}} slides",
  "eduflow.blockEditor.presentation.slideNumbers": "Slide numbers",
  "eduflow.blockEditor.presentation.slidesHeading": "Slides",
  "eduflow.blockEditor.presentation.transition": "Transition",
  "eduflow.blockEditor.presentation.transitionFade": "Fade",
  "eduflow.blockEditor.presentation.transitionNone": "None",
  "eduflow.blockEditor.presentation.transitionSlide": "Slide",
  "eduflow.blockEditor.presentation.transitionZoom": "Zoom",
  "eduflow.blockEditor.quiz.addAnswer": "Add an answer",
  "eduflow.blockEditor.quiz.addOrderingItem": "Add an item",
  "eduflow.blockEditor.quiz.aiMcqTitle": "Generate an MCQ with AI from upstream blocks",
  "eduflow.blockEditor.quiz.answerPlaceholder": "Answer {{n}}",
  "eduflow.blockEditor.quiz.answersCount": "Answers ({{count}}/10)",
  "eduflow.blockEditor.quiz.branching": "Branching",
  "eduflow.blockEditor.quiz.correctAnswer": "Correct answer",
  "eduflow.blockEditor.quiz.explanation": "Explanation",
  "eduflow.blockEditor.quiz.explanationPlaceholder": "Additional explanation...",
  "eduflow.blockEditor.quiz.false": "False",
  "eduflow.blockEditor.quiz.feedback": "Feedback",
  "eduflow.blockEditor.quiz.ifCorrect": "If correct →",
  "eduflow.blockEditor.quiz.ifIncorrect": "If incorrect →",
  "eduflow.blockEditor.quiz.markAsCorrect": "Mark as correct",
  "eduflow.blockEditor.quiz.markCorrect": "Correct answer",
  "eduflow.blockEditor.quiz.msgCorrect": "Message if correct",
  "eduflow.blockEditor.quiz.msgCorrectPlaceholder": "Well done! That's correct.",
  "eduflow.blockEditor.quiz.msgIncorrect": "Message if incorrect",
  "eduflow.blockEditor.quiz.msgIncorrectPlaceholder": "That's not the right answer.",
  "eduflow.blockEditor.quiz.nextBlockAuto": "Next block (auto)",
  "eduflow.blockEditor.quiz.orderingHint": "Items to order (current order = correct order)",
  "eduflow.blockEditor.quiz.orderingItemPlaceholder": "Item {{n}}",
  "eduflow.blockEditor.quiz.partialScoring": "Partial scoring (MCQ)",
  "eduflow.blockEditor.quiz.question": "Question",
  "eduflow.blockEditor.quiz.questionPlaceholder": "Enter your question...",
  "eduflow.blockEditor.quiz.quizType": "Quiz type",
  "eduflow.blockEditor.quiz.score": "Score",
  "eduflow.blockEditor.quiz.showCorrect": "Show correct answer",
  "eduflow.blockEditor.quiz.shuffle": "Shuffle",
  "eduflow.blockEditor.quiz.true": "True",
  "eduflow.blockEditor.quiz.typeMcq": "MCQ",
  "eduflow.blockEditor.quiz.typeOrdering": "Ordering",
  "eduflow.blockEditor.quiz.typeTrueFalse": "True / False",
  "eduflow.blockEditor.selfAssessment.addBadge": "Add",
  "eduflow.blockEditor.selfAssessment.addCriterion": "Add",
  "eduflow.blockEditor.selfAssessment.badgeInputPlaceholder": "e.g. Often, Never, Sometimes…",
  "eduflow.blockEditor.selfAssessment.badgeOptionsHint": "Short words or phrases — learners pick them as chips. If none → free text field.",
  "eduflow.blockEditor.selfAssessment.badgeOptionsLabel": "Options (badges)",
  "eduflow.blockEditor.selfAssessment.criteriaSection": "Criteria",
  "eduflow.blockEditor.selfAssessment.criterionDescription": "Description (optional)",
  "eduflow.blockEditor.selfAssessment.criterionDescriptionPh": "Clarify what the learner should notice or how to position themselves…",
  "eduflow.blockEditor.selfAssessment.criterionTitle": "Title",
  "eduflow.blockEditor.selfAssessment.criterionTitlePh": "e.g. Communication, Autonomy…",
  "eduflow.blockEditor.selfAssessment.emptyCriteria": "No criteria yet. Add at least one so learners can self-assess.",
  "eduflow.blockEditor.selfAssessment.moveDown": "Move down",
  "eduflow.blockEditor.selfAssessment.moveUp": "Move up",
  "eduflow.blockEditor.selfAssessment.panelHint": "Define each dimension to rate: a short title and, if needed, a description to guide the learner.",
  "eduflow.blockEditor.selfAssessment.panelTitle": "Self-assessment",
  "eduflow.blockEditor.selfAssessment.removeBadge": "Remove",
  "eduflow.blockEditor.selfAssessment.removeCriterion": "Remove this criterion",
  "eduflow.blockEditor.selfAssessment.responseTypeLabel": "Response type",
  "eduflow.blockEditor.selfAssessment.scaleHint": "From 1 to N (e.g. 5 = Likert)",
  "eduflow.blockEditor.selfAssessment.scaleLabel": "Rating scale",
  "eduflow.blockEditor.selfAssessment.starCountHint": "Often 5",
  "eduflow.blockEditor.selfAssessment.starCountLabel": "Number of stars",
  "eduflow.blockEditor.selfAssessment.textModeHint": "Per criterion: add badge options (selection) or leave empty for a written answer. The global comment stays below criteria in the player.",
  "eduflow.blockEditor.selfAssessment.typeNumeric": "Numbers",
  "eduflow.blockEditor.selfAssessment.typeNumericHint": "Buttons 1 to N",
  "eduflow.blockEditor.selfAssessment.typeStars": "Stars",
  "eduflow.blockEditor.selfAssessment.typeStarsHint": "Visual rating",
  "eduflow.blockEditor.selfAssessment.typeText": "Free text",
  "eduflow.blockEditor.selfAssessment.typeTextHint": "Written answer per criterion",
  "eduflow.blockEditor.shared.alignCenter": "Center",
  "eduflow.blockEditor.shared.alignLeft": "Align left",
  "eduflow.blockEditor.shared.alignRight": "Align right",
  "eduflow.blockEditor.shared.annotationCount_one": "{{count}} annotation",
  "eduflow.blockEditor.shared.annotationCount_other": "{{count}} annotations",
  "eduflow.blockEditor.shared.blocksCount": "{{count}} blocks",
  "eduflow.blockEditor.shared.bold": "Bold",
  "eduflow.blockEditor.shared.border": "Border",
  "eduflow.blockEditor.shared.bulletList": "Bullet list",
  "eduflow.blockEditor.shared.cancel": "Cancel",
  "eduflow.blockEditor.shared.choose": "Choose",
  "eduflow.blockEditor.shared.close": "Close",
  "eduflow.blockEditor.shared.configure": "Configure",
  "eduflow.blockEditor.shared.delete": "Delete",
  "eduflow.blockEditor.shared.duplicate": "Duplicate",
  "eduflow.blockEditor.shared.imageLabel": "Image",
  "eduflow.blockEditor.shared.italic": "Italic",
  "eduflow.blockEditor.shared.layoutPrefix": "Layout: ",
  "eduflow.blockEditor.shared.linked": "Linked",
  "eduflow.blockEditor.shared.maxAttempts": "Max attempts",
  "eduflow.blockEditor.shared.mediaImage": " Image",
  "eduflow.blockEditor.shared.mediaNone": " No media",
  "eduflow.blockEditor.shared.mediaVideo": " Video",
  "eduflow.blockEditor.shared.minutes": "Minutes",
  "eduflow.blockEditor.shared.noImage": "No image",
  "eduflow.blockEditor.shared.numberedList": "Numbered list",
  "eduflow.blockEditor.shared.option": "Option",
  "eduflow.blockEditor.shared.pages": "{{count}} pages",
  "eduflow.blockEditor.shared.points": "Points",
  "eduflow.blockEditor.shared.retry": "Retry",
  "eduflow.blockEditor.shared.rounded": "Rounded corners",
  "eduflow.blockEditor.shared.save": "Save",
  "eduflow.blockEditor.shared.selected": "Selected",
  "eduflow.blockEditor.shared.shadow": "Shadow",
  "eduflow.blockEditor.shared.slideCounter": "Slide {{index}}/{{total}}",
  "eduflow.blockEditor.shared.speedTicks": "{{v}}x",
  "eduflow.blockEditor.shared.strike": "Strikethrough",
  "eduflow.blockEditor.shared.underline": "Underline",
  "eduflow.blockEditor.shared.untitledSlide": "Untitled",
  "eduflow.blockEditor.shared.updatedOn": "Updated {{date}}",
  "eduflow.blockEditor.subflow.emptyPublished": "No published training available",
  "eduflow.blockEditor.subflow.emptySearch": "No training found",
  "eduflow.blockEditor.subflow.linkedTraining": "Linked sub-training",
  "eduflow.blockEditor.subflow.loadError": "Could not load trainings",
  "eduflow.blockEditor.subflow.loading": "Loading…",
  "eduflow.blockEditor.subflow.openInTab": "Open sub-training in a new tab",
  "eduflow.blockEditor.subflow.remove": "Remove",
  "eduflow.blockEditor.subflow.searchPlaceholder": "Search a published training…",
  "eduflow.blockEditor.summary.addItem": "Add a bullet",
  "eduflow.blockEditor.summary.aiRecapTitle": "Generate an AI recap from upstream blocks",
  "eduflow.blockEditor.summary.editorHint": "List concepts or steps seen in the training. Each line appears as a bullet in the player.",
  "eduflow.blockEditor.summary.emptyList": "No bullets yet. Add one.",
  "eduflow.blockEditor.summary.itemPlaceholder": "e.g. Workplace fire risks",
  "eduflow.blockEditor.text.audioTts": "Audio (TTS)",
  "eduflow.blockEditor.text.charWordCount": "{{chars}} characters · {{words}} words",
  "eduflow.blockEditor.text.content": "Content",
  "eduflow.blockEditor.text.contentPlaceholder": "Enter the text block content…",
  "eduflow.blockEditor.text.formatting": "Formatting",
  "eduflow.blockEditor.text.headingH1": "Heading 1",
  "eduflow.blockEditor.text.headingH2": "Heading 2",
  "eduflow.blockEditor.text.headingH3": "Heading 3",
  "eduflow.blockEditor.text.headingH4": "Heading 4",
  "eduflow.blockEditor.text.headingH5": "Heading 5",
  "eduflow.blockEditor.text.headingH6": "Heading 6",
  "eduflow.blockEditor.text.headingLevel": "Heading level",
  "eduflow.blockEditor.text.headingParagraph": "Paragraph",
  "eduflow.blockEditor.text.previewSoon": "Preview (coming soon)",
  "eduflow.blockEditor.text.readTime": "~{{min}} min read",
  "eduflow.blockEditor.text.speedLabel": "Speed: {{speed}}x",
  "eduflow.blockEditor.text.voice": "Voice",
  "eduflow.blockEditor.text.voiceAdam": "Adam (French male)",
  "eduflow.blockEditor.text.voiceBella": "Bella (French female)",
  "eduflow.blockEditor.text.voiceHeart": "Heart (French female)",
  "eduflow.blockEditor.text.voiceMichael": "Michael (English male)",
  "eduflow.blockEditor.text.voiceNova": "Nova (English female)",
  "eduflow.blockEditor.text.voiceSky": "Sky (English female)",
  "eduflow.blockEditor.timeline.addEvent": "Event",
  "eduflow.blockEditor.timeline.alternatingSides": "Alternating sides",
  "eduflow.blockEditor.timeline.animatedReveal": "Animated reveal",
  "eduflow.blockEditor.timeline.colorHint": "Dot color (optional)",
  "eduflow.blockEditor.timeline.colorLabel": "Color",
  "eduflow.blockEditor.timeline.datePlaceholder": "Date or period (e.g. 1789, Jan 2024)",
  "eduflow.blockEditor.timeline.descPlaceholder": "Description (shown when expanded)",
  "eduflow.blockEditor.timeline.emptyEvents": "No events yet. Add one to build the timeline.",
  "eduflow.blockEditor.timeline.events": "Events",
  "eduflow.blockEditor.timeline.horizontal": "Horizontal",
  "eduflow.blockEditor.timeline.iconAward": "Award",
  "eduflow.blockEditor.timeline.iconCheck": "Check",
  "eduflow.blockEditor.timeline.iconClock": "Clock",
  "eduflow.blockEditor.timeline.iconFlag": "Flag",
  "eduflow.blockEditor.timeline.iconStar": "Star",
  "eduflow.blockEditor.timeline.moveDown": "Move down",
  "eduflow.blockEditor.timeline.moveUp": "Move up",
  "eduflow.blockEditor.timeline.orientation": "Orientation",
  "eduflow.blockEditor.timeline.settings": "Settings",
  "eduflow.blockEditor.timeline.showConnectors": "Connector lines",
  "eduflow.blockEditor.timeline.titlePlaceholder": "Event title",
  "eduflow.blockEditor.timeline.untitled": "Untitled",
  "eduflow.blockEditor.timeline.vertical": "Vertical",
  "eduflow.blockEditor.videoSubtitles.cancel": "Cancel",
  "eduflow.blockEditor.videoSubtitles.invalidResponse": "Invalid server response.",
  "eduflow.blockEditor.videoSubtitles.invalidUrl": "Invalid track URL.",
  "eduflow.blockEditor.videoSubtitles.loadError": "Could not load.",
  "eduflow.blockEditor.videoSubtitles.loadFailed": "Could not load track ({{status}}).",
  "eduflow.blockEditor.videoSubtitles.loading": "Loading segments…",
  "eduflow.blockEditor.videoSubtitles.modalSubtitle": "One block per screen appearance. Timing is preserved; only text can be edited.",
  "eduflow.blockEditor.videoSubtitles.modalTitle": "Edit subtitles",
  "eduflow.blockEditor.videoSubtitles.noSegments": "No readable segments in the subtitle file.",
  "eduflow.blockEditor.videoSubtitles.saveFailed": "Could not save.",
  "eduflow.blockEditor.videoSubtitles.saveTrack": "Save track",
  "eduflow.blockEditor.videoSubtitles.savedToast": "Subtitles saved",
  "eduflow.blockEditor.videoSubtitles.segmentN": "Segment {{n}}",
  "eduflow.blockEditor.videoSubtitles.segmentRequiredToast": "At least one segment with text is required.",
  "eduflow.blockEditor.videoSubtitles.trackLang": "Track language: {{label}}",
  "eduflow.designer.blockLabel.audio": "Audio",
  "eduflow.blockEditor.video.autoCaptionBullet": "Audio extraction (ffmpeg) then Mistral transcription. Direct .mp4 URL recommended; not a YouTube page.",
  "eduflow.blockEditor.video.autoCaptionErrorFallback": "Check the Mistral key, ffmpeg on the server, and that the video contains audio.",
  "eduflow.blockEditor.video.autoCaptionSection": "Automatic subtitles",
  "eduflow.blockEditor.video.autoCaptionsButton": "Generate subtitles (audio + AI)",
  "eduflow.blockEditor.video.availableSubtitlesChip": "Subtitles available",
  "eduflow.blockEditor.video.completionThreshold": "Completion threshold (%)",
  "eduflow.blockEditor.video.editCueButton": "Edit subtitles (per segment)",
  "eduflow.blockEditor.video.endSeconds": "End (sec)",
  "eduflow.blockEditor.video.escHint": "Esc to close",
  "eduflow.blockEditor.video.libraryEmpty": "No videos available in your library.",
  "eduflow.blockEditor.video.libraryTitle": "Video library",
  "eduflow.blockEditor.video.libraryHint": "Pick a video already uploaded in your designer dashboard.",
  "eduflow.blockEditor.video.libraryLoading": "Loading videos…",
  "eduflow.blockEditor.video.optionalEnd": "Optional",
  "eduflow.blockEditor.video.accent.primary": "Primary",
  "eduflow.blockEditor.video.aspectFormat": "Aspect ratio",
  "eduflow.blockEditor.video.aspect.ratio169": "16:9",
  "eduflow.blockEditor.video.aspect.ratio219": "21:9",
  "eduflow.blockEditor.video.aspect.ratio43": "4:3",
  "eduflow.blockEditor.video.aspect.ratio11": "1:1",
  "eduflow.blockEditor.video.pickFromLibrary": "Select",
  "eduflow.blockEditor.video.playerBadge": "Video player",
  "eduflow.blockEditor.video.previewTitleFallback": "Video player",
  "eduflow.blockEditor.video.reduced": "Minimize",
  "eduflow.blockEditor.video.regenerateCaptions": "Regenerate",
  "eduflow.blockEditor.video.previewHint": "Upload, YouTube, or direct URL with customisable styling.",
  "eduflow.blockEditor.video.previewIframeTitle": "Video preview",
  "eduflow.blockEditor.video.subtitleBadge": "Subtitles",
  "eduflow.blockEditor.video.selected": "Selected",
  "eduflow.blockEditor.video.designTab": "Design",
  "eduflow.blockEditor.video.radius.soft": "Soft",
  "eduflow.blockEditor.video.radius.rounded": "Rounded",
  "eduflow.blockEditor.video.radius.square": "Square",
  "eduflow.blockEditor.video.shadow.soft": "Soft",
  "eduflow.blockEditor.video.shadow.glow": "Glow",
  "eduflow.blockEditor.video.shadow.dramatic": "Dramatic",
  "eduflow.blockEditor.video.shadowLabel": "Shadow",
  "eduflow.blockEditor.video.radiusCornerLabel": "Corners",
  "eduflow.blockEditor.video.themeEditorial.desc": "Light, clean, institutional",
  "eduflow.blockEditor.video.themeEditorial.label": "Editorial",
  "eduflow.blockEditor.video.themeCinema.desc": "Dark, premium, immersive",
  "eduflow.blockEditor.video.themeCinema.label": "Cinema",
  "eduflow.blockEditor.video.themeGlass.desc": "Translucent, modern, bright",
  "eduflow.blockEditor.video.themeGlass.label": "Glass",
  "eduflow.blockEditor.video.themeApp.desc": "Default, aligned with the current theme",
  "eduflow.blockEditor.video.themeApp.label": "Application",
  "eduflow.blockEditor.video.themeAccent": "Accent color",
  "eduflow.blockEditor.video.themePlayer": "Player theme",
  "eduflow.blockEditor.video.toast.autoCaptionsError": "Automatic subtitles unavailable",
  "eduflow.blockEditor.video.toast.autoCaptionsOk": "Subtitles generated",
  "eduflow.blockEditor.video.toast.autoCaptionsOkDesc": "They appear in real time during playback in the player.",
  "eduflow.blockEditor.video.toast.uploadErrorDesc": "Import failed.",
  "eduflow.blockEditor.video.toast.uploadErrorTitle": "Could not import",
  "eduflow.blockEditor.video.toast.uploadedDesc": "{{name}} is ready in your video block.",
  "eduflow.blockEditor.video.toast.uploadedTitle": "Video imported",
  "eduflow.blockEditor.video.fullscreenExpandTitle": "Open fullscreen",
  "eduflow.blockEditor.video.fullscreenHeading": "Video block",
  "eduflow.blockEditor.video.importDragTitle": "Import a video",
  "eduflow.blockEditor.video.importFormats": "MP4, WebM, OGG, MOV · max {{maxMb}} MB in the UI",
  "eduflow.blockEditor.video.noneSelected": "No video selected",
  "eduflow.blockEditor.video.playbackTab": "Playback",
  "eduflow.blockEditor.video.playbackSettingsTitle": "Playback settings",
  "eduflow.blockEditor.video.loop": "Loop",
  "eduflow.blockEditor.video.autoplay": "Autoplay",
  "eduflow.blockEditor.video.mutedStart": "Muted on start",
  "eduflow.blockEditor.video.showControls": "Show controls",
  "eduflow.blockEditor.video.embedSubtitlesYoutubeVimeo": "On {{platform}}, enable subtitles in the embedded player (CC). The player loads tracks provided by the platform.",
  "eduflow.blockEditor.video.trackReadyHint": "WebVTT track ready: in the player, subtitles follow the learner’s chosen language (all 10 player languages; translated on the fly if needed).",
  "eduflow.blockEditor.video.langTranscriptionTrack": "Language (transcription / source track)",
  "eduflow.blockEditor.video.placeholderUrlGeneric": "https://example.com/video.mp4",
  "eduflow.blockEditor.video.placeholderVimeo": "https://vimeo.com/…",
  "eduflow.blockEditor.video.placeholderYoutube": "https://www.youtube.com/watch?v=…",
  "eduflow.blockEditor.video.invalidUrlSource": "Invalid URL for this source",
  "eduflow.blockEditor.video.urlHelpDirect": "Works with direct URLs to a video file.",
  "eduflow.blockEditor.video.labelUrlGeneric": "Video URL",
  "eduflow.blockEditor.video.labelUrlVimeo": "Vimeo URL",
  "eduflow.blockEditor.video.labelUrlYoutube": "YouTube URL",
  "eduflow.blockEditor.video.readyInBlock": "Video ready in block",
  "eduflow.blockEditor.video.uploadInProgress": "Upload in progress",
  "eduflow.blockEditor.video.sectionSubtitlesDesign": "Subtitles",
  "eduflow.blockEditor.video.sourceLabel": "Video source",
  "eduflow.blockEditor.video.sourceTab": "Source",
  "eduflow.blockEditor.video.sourceUrl": "URL",
  "eduflow.blockEditor.video.sourceUpload": "File",
  "eduflow.blockEditor.video.startSeconds": "Start (sec)",
  "eduflow.blockEditor.video.showPlayerHeader": "Show player header",
  "eduflow.blockEditor.video.accent.amber": "Amber",
  "eduflow.blockEditor.video.accent.emerald": "Emerald",
  "eduflow.blockEditor.richText.collapsedHintHtml": "Minimize editor (HTML mode on)",
  "eduflow.blockEditor.richText.collapsedHintReopen": "Click to reopen the editor",
  "eduflow.blockEditor.richText.defaultPlaceholder": "Write your content here…",
  "eduflow.blockEditor.richText.fullscreenTitleFallback": "Editor",
  "eduflow.blockEditor.richText.calloutBody": "Your text here…",
  "eduflow.blockEditor.richText.calloutTitle": "Highlight title",
  "eduflow.blockEditor.richText.fullscreen": "Fullscreen",
  "eduflow.blockEditor.richText.highlight": "Highlight",
  "eduflow.blockEditor.richText.imageTab": "Image",
  "eduflow.blockEditor.richText.importTab": "Import",
  "eduflow.blockEditor.richText.infoPanelBody": "Add key information for learners.",
  "eduflow.blockEditor.richText.infoPanelTitle": "Good to know",
  "eduflow.blockEditor.richText.inlineCode": "Inline code",
  "eduflow.blockEditor.richText.insertBadge": "Badge",
  "eduflow.blockEditor.richText.insertCallout": "Callout",
  "eduflow.blockEditor.richText.insertCalloutCompact": "Insert callout",
  "eduflow.blockEditor.richText.insertImage": "Insert image",
  "eduflow.blockEditor.richText.insertImageAction": "Insert image",
  "eduflow.blockEditor.richText.insertInfoPanel": "Info panel",
  "eduflow.blockEditor.richText.insertVideo": "Insert video",
  "eduflow.blockEditor.richText.insertVideoAction": "Insert video",
  "eduflow.blockEditor.richText.libraryTab": "My images",
  "eduflow.blockEditor.richText.link": "Link",
  "eduflow.blockEditor.richText.linkOk": "OK",
  "eduflow.blockEditor.richText.linkPlaceholderHttps": "https://…",
  "eduflow.blockEditor.richText.linkPrompt": "Link URL:",
  "eduflow.blockEditor.richText.mediaFormatsHint": "PNG, JPG, GIF, WebP · max 10 MB",
  "eduflow.blockEditor.richText.minimizeToolbar": "Minimize",
  "eduflow.blockEditor.richText.modalLibraryEmpty": "No images in your library",
  "eduflow.blockEditor.richText.modalUploading": "Uploading…",
  "eduflow.blockEditor.richText.openImportTab": "Import an image",
  "eduflow.blockEditor.richText.placeholderImageUrl": "https://example.com/image.jpg",
  "eduflow.blockEditor.richText.placeholderYoutube": "https://youtube.com/watch?v=…",
  "eduflow.blockEditor.richText.quote": "Quote",
  "eduflow.blockEditor.richText.redo": "Redo",
  "eduflow.blockEditor.richText.separatorRule": "Divider",
  "eduflow.blockEditor.richText.showHtmlSource": "Show / edit HTML",
  "eduflow.blockEditor.richText.returnToVisual": "Return to visual editor",
  "eduflow.blockEditor.richText.tplBadgeLabel": "Badge",
  "eduflow.blockEditor.richText.uploadDropPrompt": "Drag and drop or",
  "eduflow.blockEditor.richText.uploadDropClick": "click to select",
  "eduflow.blockEditor.richText.heading1": "Heading 1",
  "eduflow.blockEditor.richText.heading2": "Heading 2",
  "eduflow.blockEditor.richText.heading3": "Heading 3",
  "eduflow.blockEditor.richText.justify": "Justify",
  "eduflow.blockEditor.richText.undo": "Undo",
  "eduflow.blockEditor.richText.videoYoutubePaste": "Paste the YouTube URL below",
  "eduflow.blockEditor.richText.videoYoutubeToolbar": "YouTube video",
  "eduflow.blockEditor.richText.urlTab": "URL"
};
